<template>
  <div class="page_main">
    <div
      v-if="loading"
      class="data_loading_skeleton"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div class="skeleton_columns" aria-hidden="true">
        <div class="skeleton_column skeleton_left">
          <div class="skeleton_section skeleton_overview">
            <div class="skeleton_title"><i></i><i></i></div>
            <div class="skeleton_panel skeleton_overview_panel">
              <div class="skeleton_metric_group" v-for="group in 2" :key="`metric-${group}`">
                <div class="skeleton_metric" v-for="metric in 4" :key="`metric-${metric}`">
                  <i class="skeleton_metric_icon skeleton_shimmer"></i>
                  <span class="skeleton_metric_copy">
                    <i class="skeleton_shimmer"></i>
                    <i class="skeleton_shimmer"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="skeleton_section skeleton_left_chart">
            <div class="skeleton_title"><i></i><i></i></div>
            <div class="skeleton_panel skeleton_age_panel">
              <i class="skeleton_ring skeleton_shimmer"></i>
              <div class="skeleton_age_legend">
                <i v-for="item in 6" :key="item" class="skeleton_shimmer"></i>
              </div>
            </div>
          </div>
          <div class="skeleton_section skeleton_left_chart">
            <div class="skeleton_title"><i></i><i></i></div>
            <div class="skeleton_panel skeleton_chart_panel">
              <div class="skeleton_chart_grid"><i v-for="line in 5" :key="line"></i></div>
              <div class="skeleton_bars">
                <i v-for="bar in 8" :key="bar" class="skeleton_shimmer"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="skeleton_column skeleton_center">
          <div class="skeleton_map_panel">
            <div class="skeleton_breadcrumb"><i></i><i></i><i></i></div>
            <div class="skeleton_map_board">
              <i v-for="metric in 4" :key="metric" class="skeleton_shimmer"></i>
            </div>
            <i class="skeleton_map_shape skeleton_shimmer"></i>
            <div class="skeleton_map_legend">
              <i v-for="item in 4" :key="item"><b class="skeleton_shimmer"></b><b></b></i>
            </div>
          </div>
          <div class="skeleton_center_bottom">
            <div class="skeleton_section" v-for="chart in 2" :key="`trend-${chart}`">
              <div class="skeleton_title"><i></i><i></i></div>
              <div class="skeleton_panel skeleton_chart_panel">
                <div class="skeleton_chart_grid"><i v-for="line in 5" :key="line"></i></div>
              </div>
            </div>
          </div>
        </div>

        <div class="skeleton_column skeleton_right">
          <div class="skeleton_section skeleton_alert">
            <div class="skeleton_title"><i></i><i></i></div>
            <div class="skeleton_panel skeleton_alert_panel">
              <i class="skeleton_ring skeleton_shimmer"></i>
              <div class="skeleton_status_lines">
                <i v-for="line in 3" :key="line" class="skeleton_shimmer"></i>
              </div>
            </div>
          </div>
          <div class="skeleton_section skeleton_rank">
            <div class="skeleton_title"><i></i><i></i></div>
            <div class="skeleton_panel skeleton_rank_panel">
              <div class="skeleton_rank_row" v-for="row in 3" :key="`rank-a-${row}`">
                <span><i class="skeleton_shimmer"></i><i class="skeleton_shimmer"></i></span>
                <i class="skeleton_shimmer"></i>
              </div>
            </div>
          </div>
          <div class="skeleton_section skeleton_rank">
            <div class="skeleton_title"><i></i><i></i></div>
            <div class="skeleton_panel skeleton_rank_panel">
              <div class="skeleton_rank_row" v-for="row in 4" :key="`rank-b-${row}`">
                <span><i class="skeleton_shimmer"></i><i class="skeleton_shimmer"></i></span>
                <i class="skeleton_shimmer"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="skeleton_loading_label">
        <span class="skeleton_spinner" aria-hidden="true"></span>
        正在加载数据中心…
      </div>
    </div>
    <div class="left side_list">
      <div class="general_box item_box">
        <div class="item_title_box">电梯概况</div>
        <div class="general_content tech-panel">
          <div class="item_box">
            <div class="item_list">
              <img class="icon" src="@/assets/image/d1.png" alt="" />
              <div class="list_desc">
                <div class="label">电梯</div>
                <div class="num">{{ formData.totalElevators }}<span>台</span></div>
              </div>
            </div>
            <div class="item_list">
              <img class="icon" src="@/assets/image/d2.png" alt="" />
              <div class="list_desc">
                <div class="label">物联网电梯</div>
                <div class="num">{{ formData.iotElevators }}<span>台</span></div>
              </div>
            </div>
            <div class="item_list">
              <img class="icon" src="@/assets/image/d3.png" alt="" />
              <div class="list_desc">
                <div class="label">在线电梯</div>
                <div class="num">{{ formData.onlineElevators }}<span>台</span></div>
              </div>
            </div>
            <div class="item_list">
              <img class="icon" src="@/assets/image/d4.png" alt="" />
              <div class="list_desc">
                <div class="label">离线电梯</div>
                <div class="num">{{ formData.offlineElevators }}<span>台</span></div>
              </div>
            </div>
          </div>
          <div class="line" />
          <div class="item_box">
            <div class="item_list">
              <img class="icon" src="@/assets/image/d5.png" alt="" />
              <div class="list_desc">
                <div class="label">使用单位数量</div>
                <div class="num">{{ formData.usageUnit }}</div>
                <!-- <div class="num">30</div> -->
              </div>
            </div>
            <div class="item_list">
              <img class="icon" src="@/assets/image/d6.png" alt="" />
              <div class="list_desc">
                <div class="label">物联网覆盖率</div>
                <div class="num">
                  {{ percentage(formData.iotElevators, formData.totalElevators) }}<span>%</span>
                </div>
              </div>
            </div>
            <div class="item_list">
              <img class="icon" src="@/assets/image/d7.png" alt="" />
              <div class="list_desc">
                <div class="label">物联网在线率</div>
                <div class="num">
                  {{ percentage(formData.onlineElevators, formData.iotElevators) }}<span>%</span>
                </div>
              </div>
            </div>
            <div class="item_list">
              <img class="icon" src="@/assets/image/d8.png" alt="" />
              <div class="list_desc">
                <div class="label">物联网离线率</div>
                <div class="num">
                  {{
                    percentage(
                      formData.iotElevators - formData.onlineElevators,
                      formData.iotElevators
                    )
                  }}<span>%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="thirtydays_box item_box">
        <div class="item_title_box">电梯梯龄统计</div>
        <!-- <div class="item_title_box">近30天故障分布统计</div> -->
        <div class="thirtydays_content tech-panel" id="malfunction">
          <div v-if="loading" class="module_loading">
            <div class="loading_spinner"></div>
          </div>
          <img v-else-if="!hasAgeData" class="empty_image" src="@/assets/image/nothing.png" alt="暂无数据" />
          <div v-else class="center_num center_num--left">
            <div class="num">{{ ageTotal }}</div>
            <div class="label">电梯总数</div>
          </div>
        </div>
      </div>
      <div class="charts_bottom_box item_box">
        <div class="item_title_box">近30天告警类型统计</div>
        <div class="charts_container tech-panel" id="warnTypeThirty">
          <div v-if="loading" class="module_loading">
            <div class="loading_spinner"></div>
          </div>
          <img
            v-else-if="thirtyWarnType.length === 0"
            class="empty_image"
            src="@/assets/image/nothing.png"
            alt="暂无数据"
          />
        </div>
      </div>
    </div>
    <div class="center">
      <div class="map_box">
        <div class="map_breadcrumb" aria-label="当前位置">
          <span
            v-for="(item, index) in mapBreadcrumb"
            :key="item"
            class="map_breadcrumb_part"
          >
            <span v-if="index > 0" class="map_breadcrumb_separator">&gt;</span>
            <button
              v-if="index > 0 && index < mapBreadcrumb.length - 1"
              type="button"
              class="map_breadcrumb_link"
              @click="handleBreadcrumbClick(index)"
            >{{ item }}</button>
            <span v-else :class="{ map_breadcrumb_active: index === mapBreadcrumb.length - 1 }">
              {{ item }}
            </span>
          </span>
        </div>
        <div class="map_content" id="map"></div>
        <div v-if="mapLoading" class="map_loading_overlay" role="status" aria-live="polite">
          <i class="map_loading_shape skeleton_shimmer" aria-hidden="true"></i>
          <span>地图数据加载中…</span>
        </div>
        <ul class="map_legend tech-panel" aria-label="电梯数量区间图例">
          <li
            v-for="item in mapLegend"
            :key="item.label"
            class="map_legend_item"
          >
            <span
              class="map_legend_swatch"
              :style="{ backgroundColor: item.color }"
              aria-hidden="true"
            ></span>
            <span>{{ item.label }}</span>
          </li>
          <li v-if="mapLegend.length === 0" class="map_legend_empty">暂无地图数据</li>
        </ul>
        <div class="map_board tech-panel">
          <div class="board_item">
            <div class="board_label">电梯总数</div>
            <div class="board_num">{{ formData.totalElevators }}</div>
          </div>
          <div class="board_item">
            <div class="board_label">物联网电梯数</div>
            <div class="board_num">{{ formData.iotElevators }}</div>
          </div>
          <div class="board_item board_item--online">
            <div class="board_label">物联网在线数</div>
            <div class="board_num">{{ formData.onlineElevators }}</div>
          </div>
          <div class="board_item board_item--offline">
            <div class="board_label">物联网离线数</div>
            <div class="board_num">{{ formData.offlineElevators }}</div>
          </div>
        </div>
      </div>
      <div class="center_bottom">
        <div class="charts_bottom_box item_box">
          <div class="item_title_box">近7天电梯告警率趋势</div>
          <div class="charts_container tech-panel" id="warnTypeSeven">
            <div v-if="loading" class="module_loading">
              <div class="loading_spinner"></div>
            </div>
            <img
              v-else-if="sevenWarn.length === 0"
              class="empty_image"
              src="@/assets/image/nothing.png"
              alt="暂无数据"
            />
          </div>
        </div>
        <div class="charts_bottom_box item_box">
          <div class="item_title_box">近30天困人次数趋势</div>
          <div class="charts_container tech-panel" id="warnTime">
            <div v-if="loading" class="module_loading">
              <div class="loading_spinner"></div>
            </div>
            <img
              v-else-if="thirtyWarnTime.length === 0"
              class="empty_image"
              src="@/assets/image/nothing.png"
              alt="暂无数据"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="right side_list">
      <div class="today_warn_box item_box">
        <div class="item_title_box">今日告警</div>
        <div class="today_warn_content tech-panel" :aria-busy="loading">
          <div class="today_type_distribution" aria-label="告警类型分布">
            <div class="today_charts">
              <div class="today_chart_canvas" id="warnToday" aria-hidden="true"></div>
              <div class="center_num">
                <div class="today_chart_title">类型分布</div>
              </div>
            </div>
            <ul class="today_type_legend" aria-label="告警类型图例">
              <li v-for="item in todayTypeChartData" :key="item.name">
                <span
                  class="type_marker"
                  :style="{ backgroundColor: item.itemStyle.color }"
                  aria-hidden="true"
                ></span>
                <span class="type_name">{{ item.name }}</span>
              </li>
            </ul>
          </div>
          <div class="today_status_summary">
            <div class="today_status_title">处理状态</div>
            <dl class="today_legend" aria-label="告警处理状态">
              <div
                v-for="item in todayStatusData"
                :key="item.name"
                class="legend_list"
                :class="[item.status, { is_empty: item.value === 0 }]"
              >
                <dt class="status">
                  <span
                    class="status_marker"
                    :style="{ backgroundColor: item.itemStyle.color }"
                    aria-hidden="true"
                  ></span>
                  <span class="status_label">{{ item.name }}</span>
                </dt>
                <dd class="value">{{ loading ? "—" : item.value }}</dd>
              </div>
            </dl>
          </div>
        </div>
      </div>
      <div class="real_time item_box">
        <div class="item_title_box">近30天告警维保单位TOP10</div>
        <div class="real_content tech-panel">
          <div class="real_box" :class="{ empty_state: realWarnList.length === 0 }">
            <div class="swiper-wrapper">
              <div
                class="real_page swiper-slide"
                v-for="(page, pageIndex) in rankedRealWarnPages"
                :key="`real-page-${pageIndex}`"
              >
                <div
                  class="real_list"
                  v-for="(item, index) in page"
                  :key="`real-item-${pageIndex}-${index}`"
                >
                  <div class="rank_item">
                    <div class="rank_info">
                      <span class="rank_badge">
                        <img v-if="pageIndex === 0 && index === 0" class="icon" src="@/assets/image/n1.png" alt="" />
                        <img v-else-if="pageIndex === 0 && index === 1" class="icon" src="@/assets/image/n2.png" alt="" />
                        <img v-else-if="pageIndex === 0 && index === 2" class="icon" src="@/assets/image/n3.png" alt="" />
                        <span class="rank_order">NO.{{ pageIndex * 4 + index + 1 }}</span>
                      </span>
                      <div class="sort">{{ item.faultType }}</div>
                      <div :class="pageIndex === 0 && index === 0 ? 'value first' : 'value'">{{ item.count }}</div>
                    </div>
                    <div class="process_box">
                      <div
                        :class="pageIndex === 0 && index === 0 ? 'process active' : 'process'"
                        :style="'width:' + (realWarnMax ? (Number(item.count) / realWarnMax) * 100 : 0) + '%;'"
                      >
                        <div class="process_line"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="loading" class="module_loading">
              <div class="loading_spinner"></div>
            </div>
            <img
              v-else-if="realWarnList.length == 0"
              class="nothing"
              src="@/assets/image/nothing.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="charts_bottom_box item_box">
        <div class="item_title_box">近30天告警使用单位TOP10</div>
        <div class="charts_container use_box tech-panel">
          <div class="swiper-wrapper">
            <div
              class="unit_page swiper-slide"
              v-for="(page, pageIndex) in rankedThirtyWarnUnitPages"
              :key="`unit-page-${pageIndex}`"
            >
              <div
                class="unit_list"
                v-for="(item, index) in page"
                :key="`unit-item-${pageIndex}-${index}`"
              >
                <div class="sort_item">
                  <div class="sort_info">
                    <span class="rank_badge">
                      <img v-if="pageIndex === 0 && index === 0" class="icon" src="@/assets/image/n1.png" alt="" />
                      <img v-else-if="pageIndex === 0 && index === 1" class="icon" src="@/assets/image/n2.png" alt="" />
                      <img v-else-if="pageIndex === 0 && index === 2" class="icon" src="@/assets/image/n3.png" alt="" />
                      <span class="rank_order">NO.{{ pageIndex * 3 + index + 1 }}</span>
                    </span>
                    <div class="sort">{{ item.faultType }}</div>
                    <div :class="pageIndex === 0 && index === 0 ? 'value first' : 'value'">
                      {{ item.count }}
                    </div>
                  </div>
                  <div class="process_box">
                    <div
                      :class="pageIndex === 0 && index === 0 ? 'process active' : 'process'"
                      :style="
                        'width:' + (unitWarnMax ? (Number(item.count) / unitWarnMax) * 100 : 0) + '%;'
                    "
                  >
                    <div class="process_line"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="loading" class="module_loading">
            <div class="loading_spinner"></div>
          </div>
          <img
            v-else-if="thirtyWarnUnit.length === 0"
            class="empty_image"
            src="@/assets/image/nothing.png"
            alt="暂无数据"
          />
        </div>
      </div>
    </div>
    <div
      v-if="elevatorListVisible"
      class="elevator_list_overlay"
      role="presentation"
      @click.self="closeElevatorList"
      @keydown.esc="closeElevatorList"
    >
      <section
        class="elevator_list_modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="elevator-list-title"
        tabindex="-1"
        @click.stop
      >
        <div class="elevator_list_header">
          <div>
            <h2 id="elevator-list-title">电梯列表</h2>
            <span class="elevator_list_scope">{{ elevatorListArea }}</span>
          </div>
          <button
            ref="elevatorListClose"
            type="button"
            class="elevator_list_close"
            aria-label="关闭电梯列表"
            @click="closeElevatorList"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="elevator_list_body">
          <div class="elevator_list_filters">
            <label class="elevator_list_filter">
              <span>使用单位</span>
              <input v-model.trim="elevatorListDraftFilters.usageUnit" type="text" placeholder="请输入" />
            </label>
            <label class="elevator_list_filter">
              <span>电梯名称</span>
              <input v-model.trim="elevatorListDraftFilters.elevatorName" type="text" placeholder="请输入" />
            </label>
            <button type="button" class="elevator_list_action elevator_list_action--primary" @click="queryElevatorList">
              查询
            </button>
            <button type="button" class="elevator_list_action" @click="resetElevatorList">
              重置
            </button>
          </div>
          <div class="elevator_list_table_wrap">
            <table class="elevator_list_table">
              <thead>
                <tr>
                  <th scope="col">序号</th>
                  <th scope="col">电梯名称</th>
                  <th scope="col">使用单位</th>
                  <th scope="col">维保单位</th>
                  <th scope="col">联网状态</th>
                  <th scope="col">实时数据</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in filteredElevatorList"
                  :key="item.id"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.elevatorName }}</td>
                  <td>{{ item.usageUnit }}</td>
                  <td>{{ item.maintenanceUnit }}</td>
                  <td>
                    <span :class="['elevator_list_status', item.online ? 'is-online' : 'is-offline']">
                      {{ item.online ? '在线' : '离线' }}
                    </span>
                  </td>
                  <td>
                    <button
                      type="button"
                      class="elevator_list_view"
                      @click="viewElevatorData(item)"
                    >
                      查看
                    </button>
                  </td>
                </tr>
                <tr v-if="filteredElevatorList.length === 0" class="elevator_list_empty">
                  <td colspan="6">暂无匹配的电梯数据</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
    <div
      v-if="elevatorMonitorVisible && elevatorMonitorData"
      class="elevator_monitor_overlay"
      role="presentation"
      @click.self="closeElevatorMonitor"
      @keydown.esc="closeElevatorMonitor"
    >
      <section
        class="elevator_monitor_modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="elevator-monitor-title"
        tabindex="-1"
        @click.stop
      >
        <div class="elevator_monitor_header">
          <h2 id="elevator-monitor-title">电梯实时运行监控</h2>
          <button
            ref="elevatorMonitorClose"
            type="button"
            class="elevator_monitor_close"
            aria-label="关闭实时运行监控"
            @click="closeElevatorMonitor"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="elevator_monitor_info">
          <div class="elevator_monitor_info_item">
            <span>电梯名称：</span>{{ elevatorMonitorData.elevatorName }}
          </div>
          <div class="elevator_monitor_info_item">
            <span>注册代码：</span>{{ elevatorMonitorData.registrationCode }}
          </div>
          <div class="elevator_monitor_info_item">
            <span>使用单位：</span>{{ elevatorMonitorData.usageUnit }}
          </div>
          <div class="elevator_monitor_info_item">
            <span>维保单位：</span>{{ elevatorMonitorData.maintenanceUnit }}
          </div>
        </div>
        <div class="elevator_monitor_body">
          <div class="elevator_monitor_video" role="img" aria-label="电梯监控视频占位">
            <span class="elevator_monitor_play" aria-hidden="true"></span>
          </div>
          <div class="elevator_monitor_side">
            <div class="elevator_monitor_status_grid">
              <div class="elevator_monitor_status_card">
                <strong>{{ elevatorMonitorData.operationStatus }}</strong>
                <span>电梯运行状态</span>
              </div>
              <div class="elevator_monitor_status_card">
                <strong>{{ elevatorMonitorData.doorStatus }}</strong>
                <span>电梯门状态</span>
              </div>
              <div class="elevator_monitor_status_card">
                <strong>{{ elevatorMonitorData.currentFloor }}</strong>
                <span>当前楼层</span>
              </div>
              <div class="elevator_monitor_status_card">
                <strong>{{ elevatorMonitorData.passengerCount }}</strong>
                <span>轿厢人数</span>
              </div>
              <div class="elevator_monitor_status_card">
                <strong>{{ elevatorMonitorData.levelingStatus }}</strong>
                <span>平层状态</span>
              </div>
            </div>
            <div class="elevator_monitor_statistics">
              <h3>运行数据统计</h3>
              <div class="elevator_monitor_statistics_grid">
                <div v-for="item in elevatorMonitorData.statistics" :key="item.label">
                  <span>{{ item.label }}</span>
                  <strong>{{ item.value }}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <TheMask ref="mask" />
  </div>
</template>

<script>
import { getDataCenter, getMapData, getBoardData } from "@/api/user";
import { areaIdMap, areaNameMap, mapDataToEcharts, mapDataToPoints } from "@/utils";
import { CHART, mapPointSize } from "@/utils/theme";

import Swiper from "swiper"; // 注意引入的是Swiper
import * as echarts from "echarts";
import "echarts-gl";
import TheMask from "../theMask/index.vue";

import hubeiGeoJson from "@/utils/map.json"; // 湖北省geojson
// 市区geojson示例引入写法（实际建议动态import或按需加载）
import shiyan from "@/utils/cities/shiyan.json";
import shennongjia from "@/utils/cities/shennongjia.json";
import enshi from "@/utils/cities/enshi.json";
import xiangyang from "@/utils/cities/xiangyang.json";
import yichang from "@/utils/cities/yichang.json";
import suizhou from "@/utils/cities/suizhou.json";
import jingmen from "@/utils/cities/jingmen.json";
import jingzhou from "@/utils/cities/jingzhou.json";
import xiaogan from "@/utils/cities/xiaogan.json";
import tianmen from "@/utils/cities/tianmen.json";
import qianjiang from "@/utils/cities/qianjiang.json";
import xiantao from "@/utils/cities/xiantao.json";
import wuhan from "@/utils/cities/wuhan.json";
import huanggang from "@/utils/cities/huanggang.json";
import ezhou from "@/utils/cities/ezhou.json";
import huangshi from "@/utils/cities/huangshi.json";
import xianning from "@/utils/cities/xianning.json";

// 今日告警类型暂使用原有示例数据。
// 接入后端类型统计时，映射为 { name, value } 后替换 todayWarnType 的数据来源。
const MOCK_TODAY_WARN_TYPES = [
  { name: "重复开关门", value: 365 },
  { name: "非平层停梯", value: 365 },
  { name: "非平层开门", value: 365 },
  { name: "蹲底", value: 365 },
  { name: "困人（AI）", value: 365 },
  { name: "开门故障", value: 365 },
];

// 地图与图例共用四档离散色阶，确保区间颜色和区域实际颜色完全一致。
const MAP_REGION_COLORS = {
  highest: "#7FF3FF",
  high: "#00D4FF",
  medium: "#0085D6",
  low: "#126B96",
  zero: "#123A52",
};
const MAP_LABEL_BASE_DISTANCE = 94;

// 县级电梯列表暂使用前端固定数据，后续接入接口时只替换此处数据来源。
const MOCK_ELEVATOR_LIST = [
  {
    id: 1,
    elevatorName: "云矩智能1-1#",
    usageUnit: "云启点",
    maintenanceUnit: "云启点",
    online: true,
  },
  {
    id: 2,
    elevatorName: "云矩智能1-2#",
    usageUnit: "云启点",
    maintenanceUnit: "云启点",
    online: true,
  },
  {
    id: 3,
    elevatorName: "云矩智能1-3#",
    usageUnit: "云启点",
    maintenanceUnit: "云启点",
    online: false,
  },
  {
    id: 4,
    elevatorName: "云矩智能1-4#",
    usageUnit: "云启点",
    maintenanceUnit: "云启点",
    online: true,
  },
  {
    id: 5,
    elevatorName: "云矩智能1-5#",
    usageUnit: "云启点",
    maintenanceUnit: "云启点",
    online: true,
  },
  {
    id: 6,
    elevatorName: "云矩智能1-6#",
    usageUnit: "云启点",
    maintenanceUnit: "云启点",
    online: true,
  },
  {
    id: 7,
    elevatorName: "云矩智能1-7#",
    usageUnit: "云启点",
    maintenanceUnit: "云启点",
    online: true,
  },
];

const MOCK_ELEVATOR_MONITOR = {
  registrationCode: "31104205002021071195",
  operationStatus: "上行",
  doorStatus: "开启",
  currentFloor: "1层",
  passengerCount: "1人",
  levelingStatus: "正常",
  statistics: [
    { label: "开关门次数", value: "8446次" },
    { label: "运行次数", value: "8446次" },
    { label: "运行距离", value: "8446米" },
    { label: "运行时长", value: "84.46小时" },
    { label: "钢丝绳弯折次数", value: "8446次" },
  ],
};

function createMapColorScale(maxValue) {
  const max = Math.max(0, Math.ceil(Number(maxValue) || 0));
  if (max === 0) {
    return {
      legend: [{ label: "0", color: MAP_REGION_COLORS.zero }],
      getColor: () => MAP_REGION_COLORS.zero,
    };
  }

  const rawStep = max / 4;
  const magnitude = Math.pow(
    10,
    Math.max(0, Math.floor(Math.log10(rawStep)))
  );
  const step = Math.max(1, Math.ceil(rawStep / magnitude) * magnitude);
  const firstThreshold = step;
  const secondThreshold = step * 2;
  const thirdThreshold = step * 3;
  const formatRange = (min, max) => min === max ? `${min}` : `${min}–${max}`;
  const legend = [
    { label: `>${thirdThreshold}`, color: MAP_REGION_COLORS.highest },
    { label: formatRange(secondThreshold, thirdThreshold), color: MAP_REGION_COLORS.high },
    { label: formatRange(firstThreshold, secondThreshold - 1), color: MAP_REGION_COLORS.medium },
  ];
  // 数量为整数，非零区间不包含 0，也不重复包含相邻档的边界。
  if (firstThreshold > 1) {
    legend.push({
      label: formatRange(1, firstThreshold - 1),
      color: MAP_REGION_COLORS.low,
    });
  }
  legend.push({ label: "0", color: MAP_REGION_COLORS.zero });
  const getColor = (value) => {
    const count = Math.max(0, Number(value) || 0);
    if (count === 0) return MAP_REGION_COLORS.zero;
    if (count > thirdThreshold) return MAP_REGION_COLORS.highest;
    if (count >= secondThreshold) return MAP_REGION_COLORS.high;
    if (count >= firstThreshold) return MAP_REGION_COLORS.medium;
    return MAP_REGION_COLORS.low;
  };

  return { legend, getColor };
}

function getMapFitView(size, viewport, alpha = 46, beta = 0, fov = 50, points = [], centerMap = false) {
  const alphaRadians = alpha * Math.PI / 180;
  const betaRadians = beta * Math.PI / 180;
  const sinAlpha = Math.sin(alphaRadians);
  const cosAlpha = Math.cos(alphaRadians);
  const sinBeta = Math.sin(betaRadians);
  const cosBeta = Math.cos(betaRadians);
  const verticalLimit = Math.tan(fov * Math.PI / 360) * 0.98;
  const horizontalLimit = verticalLimit * viewport.width / viewport.height;
  let distance = 30;
  let minHorizontal = Infinity;
  let maxHorizontal = -Infinity;
  let minVertical = Infinity;
  let maxVertical = -Infinity;
  let maxDepth = -Infinity;
  const fitPoint = (x, y, z) => {
    const cameraX = x * cosBeta - z * sinBeta;
    const rotatedZ = x * sinBeta + z * cosBeta;
    const cameraY = y * cosAlpha - rotatedZ * sinAlpha;
    const nearOffset = y * sinAlpha + rotatedZ * cosAlpha;
    if (centerMap) {
      // 同时求相机平面内的中心和视距，让透视后的上下、左右边缘充分利用视口。
      minHorizontal = Math.min(minHorizontal, cameraX - horizontalLimit * nearOffset);
      maxHorizontal = Math.max(maxHorizontal, cameraX + horizontalLimit * nearOffset);
      minVertical = Math.min(minVertical, cameraY - verticalLimit * nearOffset);
      maxVertical = Math.max(maxVertical, cameraY + verticalLimit * nearOffset);
      maxDepth = Math.max(maxDepth, nearOffset);
      return;
    }
    distance = Math.max(
      distance,
      nearOffset + Math.abs(cameraX) / horizontalLimit,
      nearOffset + Math.abs(cameraY) / verticalLimit
    );
  };

  // 使用实际地图轮廓和光柱顶点，避免包围盒中不存在的角点把地图缩得过小。
  if (points.length > 0) {
    points.forEach(([x, y, z]) => fitPoint(x, y, z));
  } else {
    [-size[0] / 2, size[0] / 2].forEach((x) => {
      [0, size[1]].forEach((y) => {
        [-size[2] / 2, size[2] / 2].forEach((z) => fitPoint(x, y, z));
      });
    });
  }
  if (!centerMap) return { distance, center: [0, 0, 0] };

  distance = Math.max(
    30,
    maxDepth + 1,
    (maxHorizontal - minHorizontal) / (2 * horizontalLimit),
    (maxVertical - minVertical) / (2 * verticalLimit)
  );
  const centerX = (maxHorizontal + minHorizontal) / 2;
  const centerY = (maxVertical + minVertical) / 2;
  return {
    distance,
    center: [
      centerX * cosBeta - centerY * sinAlpha * sinBeta,
      centerY * cosAlpha,
      -centerX * sinBeta - centerY * sinAlpha * cosBeta,
    ],
  };
}

function getMap2DLayout(viewport, aspect) {
  const width = Math.min(viewport.width, viewport.height * aspect);
  const height = width / aspect;
  return {
    layoutCenter: [viewport.left + viewport.width / 2, viewport.top + viewport.height / 2],
    layoutSize: Math.max(width, height) * 0.98,
  };
}

function getMapLabelScale(distance, baseDistance = MAP_LABEL_BASE_DISTANCE) {
  const cameraDistance = Number(distance);
  if (!Number.isFinite(cameraDistance) || cameraDistance <= 0) return 1;
  return Math.max(0.6, Math.min(1, baseDistance / cameraDistance));
}

function scaleMapLabelRich(baseRich, scale) {
  const name = {
    ...baseRich.name,
    fontSize: Math.max(8, Math.round(baseRich.name.fontSize * scale)),
  };
  if (baseRich.name.lineHeight) {
    name.lineHeight = Math.max(10, Math.round(baseRich.name.lineHeight * scale));
  }
  return {
    name,
    count: {
      ...baseRich.count,
      fontSize: Math.max(7, Math.round(baseRich.count.fontSize * scale)),
    },
  };
}

export default {
  name: "IndexHome",
  components: {
    TheMask,
  },
  data() {
    return {
      formData: {
        totalElevators: 0,
        iotElevators: 0,
        onlineElevators: 0,
        offlineElevators: 0,
        usageUnit: 0,
        daysRelieveNo: 0,
        serviceNo: 0,
        dayNotNo: 0,
      },
      todayWarnType: MOCK_TODAY_WARN_TYPES.map((item) => ({ ...item })),
      thirtyFault: [],
      thirtyWarnType: [],
      sevenWarn: [],
      thirtyWarnTime: [],
      thirtyWarnUnit: [],
      boardForm: {
        threeYearsNumber: 0,
        twoYearsNumber: 0,
        sixYearsNumber: 0,
        nineYearsNumber: 0,
        twelveYearsNumber: 0,
        fifteenYearsNumber: 0,
      },
      unitTotal: 0,
      currentLevel: "province", // 省级或市级
      currentMapName: "hubei", // 当前注册的地图名称
      currentMapTitle: "湖北省",
      // url: "wss://lift.yqdiot.cn/websocket/eventMessage",
      // url: "ws://192.168.0.103:8380/websocket/eventMessage",
      // webSocket: null,
      first: true,
      realWarnList: [],
      code: "",
      parentCode: "",
      codeText: "",
      resizeHandler: null,
      mapResizeObserver: null,
      mapFitDistance: null,
      mapFitCenter: [0, 0, 0],
      mapFitPoints: Object.freeze([]),
      mapRotateTimer: null,
      mapLabelUpdateTimer: null,
      mapLegend: [],
      elevatorListVisible: false,
      elevatorListArea: "",
      elevatorListRows: [],
      elevatorMonitorVisible: false,
      elevatorMonitorData: null,
      elevatorListFilters: {
        usageUnit: "",
        elevatorName: "",
      },
      elevatorListDraftFilters: {
        usageUnit: "",
        elevatorName: "",
      },
      useUnitSwiper: null,
      realWarnSwiper: null,
      kpiRafId: null,
      loading: true,
      mapRequestsPending: 0,
      mapHasLoaded: false,
      codeList: [
        "420100",
        "420200",
        "420300",
        "420500",
        "420600",
        "420700",
        "420800",
        "420900",
        "421000",
        "421100",
        "421200",
        "421300",
        "422800",
        "429004",
        "429005",
        "429006",
        "429021",
      ],
    };
  },
  computed: {
    hasAgeData() {
      return [
        this.boardForm.threeYearsNumber,
        this.boardForm.twoYearsNumber,
        this.boardForm.sixYearsNumber,
        this.boardForm.nineYearsNumber,
        this.boardForm.twelveYearsNumber,
        this.boardForm.fifteenYearsNumber,
      ].some((value) => Number(value) > 0);
    },
    ageTotal() {
      return [
        this.boardForm.threeYearsNumber,
        this.boardForm.twoYearsNumber,
        this.boardForm.sixYearsNumber,
        this.boardForm.nineYearsNumber,
        this.boardForm.twelveYearsNumber,
        this.boardForm.fifteenYearsNumber,
      ].reduce((sum, v) => sum + (Number(v) || 0), 0);
    },
    todayTypeChartData() {
      return this.todayWarnType.map((item, index) => ({
        ...item,
        itemStyle: { color: CHART.palette[index % CHART.palette.length] },
      }));
    },
    todayStatusData() {
      return [
        {
          name: "已解除",
          value: Math.max(0, Number(this.formData.daysRelieveNo) || 0),
          status: "success",
          itemStyle: { color: "#00cb61" },
        },
        {
          name: "维修中",
          value: Math.max(0, Number(this.formData.serviceNo) || 0),
          status: "warn",
          itemStyle: { color: "#e2b400" },
        },
        {
          name: "未解除",
          value: Math.max(0, Number(this.formData.dayNotNo) || 0),
          status: "danger",
          itemStyle: { color: "#ff5f4a" },
        },
      ];
    },
    rankedThirtyWarnUnit() {
      return this.thirtyWarnUnit.slice().sort((a, b) => (
        (Number(b.count) || 0) - (Number(a.count) || 0)
      ));
    },
    rankedThirtyWarnUnitPages() {
      const pages = [];
      const pageSize = 3;
      for (let index = 0; index < this.rankedThirtyWarnUnit.length; index += pageSize) {
        pages.push(this.rankedThirtyWarnUnit.slice(index, index + pageSize));
      }
      return pages;
    },
    rankedRealWarnList() {
      return this.realWarnList.slice().sort((a, b) => (
        (Number(b.count) || 0) - (Number(a.count) || 0)
      ));
    },
    rankedRealWarnPages() {
      const pages = [];
      const pageSize = 4;
      for (let index = 0; index < this.rankedRealWarnList.length; index += pageSize) {
        pages.push(this.rankedRealWarnList.slice(index, index + pageSize));
      }
      return pages;
    },
    unitWarnMax() {
      return Math.max(0, ...this.thirtyWarnUnit.map((item) => Number(item.count) || 0));
    },
    realWarnMax() {
      return Math.max(0, ...this.realWarnList.map((item) => Number(item.count) || 0));
    },
    mapBreadcrumb() {
      const breadcrumb = ["中国", "湖北"];
      if (this.currentMapTitle && this.currentMapTitle !== "湖北省") {
        breadcrumb.push(this.currentMapTitle);
      }
      return breadcrumb;
    },
    mapLoading() {
      return this.mapRequestsPending > 0 && !this.mapHasLoaded;
    },
    filteredElevatorList() {
      const usageUnit = this.elevatorListFilters.usageUnit.toLowerCase();
      const elevatorName = this.elevatorListFilters.elevatorName.toLowerCase();
      return this.elevatorListRows.filter((item) => (
        (!usageUnit || item.usageUnit.toLowerCase().includes(usageUnit))
        && (!elevatorName || item.elevatorName.toLowerCase().includes(elevatorName))
      ));
    },
  },
  watch: {
    todayWarnType: {
      deep: true,
      handler() {
        this.$nextTick(() => this.initWarnToday());
      },
    },
  },
  mounted() {
    const query = window.location.hash.split("?")[1];
    // 解析 URL 参数
    const urlParams = new URLSearchParams(query);
    const token = urlParams.get("token");
    const code = urlParams.get("code");
    if (code) {
      localStorage.setItem("code", code); // 或存到 Vuex
    }
    if (token) {
      localStorage.setItem("token", token); // 或存到 Vuex
    }

    // 响应式：窗口变化时重绘 echarts
    this.resizeHandler = () => this.resizeCharts();
    window.addEventListener("resize", this.resizeHandler);
    // 响应式布局下 echarts init 时容器可能尚未 layout 完毕，
    // 延迟 300ms 强制首次 resize，防地图/图表渲染成 0×0
    setTimeout(() => this.resizeCharts(), 300);

    this.$nextTick(() => {
      const mapElement = document.getElementById("map");
      if (window.ResizeObserver && mapElement) {
        this.mapResizeObserver = new window.ResizeObserver(() => {
          const chart = echarts.getInstanceByDom(mapElement);
          if (chart && !chart.isDisposed()) {
            chart.resize();
            this.updateMapResponsive(chart);
          }
        });
        this.mapResizeObserver.observe(mapElement);
      }
      // this.join();
      this.getData();
      this.initWarnToday();
      this.code = localStorage.getItem("code") || "";
      if (
        this.code == "429004" ||
        this.code == "429005" ||
        this.code == "429006" ||
        this.code == "429021"
      ) {
        this.parentCode = this.code;
      } else {
        this.parentCode = this.code.slice(0, 4) + "00";
      }
      this.codeText = areaIdMap[Number(this.parentCode)] || null;
      if (this.codeText) {
        this.currentLevel = "city";
        this.loadCityMap(this.codeText);
      } else {
        this.initMap();
      }
    });
  },
  beforeDestroy() {
    const todayChartElement = document.getElementById("warnToday");
    const todayChart = todayChartElement && echarts.getInstanceByDom(todayChartElement);
    if (todayChart) {
      todayChart.dispose();
    }
    if (this.resizeHandler) {
      window.removeEventListener("resize", this.resizeHandler);
      this.resizeHandler = null;
    }
    if (this.mapResizeObserver) {
      this.mapResizeObserver.disconnect();
      this.mapResizeObserver = null;
    }
    if (this.mapRotateTimer) {
      clearTimeout(this.mapRotateTimer);
      this.mapRotateTimer = null;
    }
    if (this.mapLabelUpdateTimer) {
      clearTimeout(this.mapLabelUpdateTimer);
      this.mapLabelUpdateTimer = null;
    }
    if (this.useUnitSwiper) {
      this.useUnitSwiper.destroy(true, true);
      this.useUnitSwiper = null;
    }
    if (this.realWarnSwiper) {
      this.realWarnSwiper.destroy(true, true);
      this.realWarnSwiper = null;
    }
    if (this.kpiRafId) {
      cancelAnimationFrame(this.kpiRafId);
      this.kpiRafId = null;
    }
  },
  // watch: {
  //   realWarnList() {
  //     this.$nextTick(() => {
  //       this.swiperInitWarn(); // 等 DOM 更新完成再初始化 Swiper
  //     });
  //   },
  // },
  methods: {
    resizeCharts() {
      [
        "map",
        "warnToday",
        "warnTime",
        "warnTypeSeven",
        "warnTypeThirty",
        "malfunction",
      ].forEach((id) => {
        const element = document.getElementById(id);
        const chart = element && echarts.getInstanceByDom(element);
        if (chart && !chart.isDisposed()) {
          chart.resize();
          if (id === "map") {
            this.updateMapResponsive(chart);
          }
          if (id === "warnTypeThirty") {
            this.updateWarnTypeResponsive(chart);
          }
          if (id === "warnTypeSeven" || id === "warnTime") {
            this.updateTrendResponsive(chart, id === "warnTime" ? "line" : "bar");
          }
        }
      });
    },
    getMapViewport(chart) {
      const mapElement = chart.getDom();
      const width = Math.max(1, chart.getWidth());
      const height = Math.max(1, chart.getHeight());
      const paddingX = width * 0.01;
      const paddingY = height * 0.01;
      let top = paddingY;
      // 避开顶部统计卡片，面包屑保留在左上角，不额外挤占整行地图空间。
      const boardElement = mapElement.parentElement.querySelector(".map_board");
      if (boardElement) {
        top = Math.max(top, boardElement.offsetTop + boardElement.offsetHeight - mapElement.offsetTop + paddingY);
      }
      top = Math.min(top, height - 1);
      // 保持视口宽高不变，整体上移画布高度的 4%，为下边缘和图例留出间距。
      const upwardOffset = Math.min(top, height * 0.04);
      return {
        left: paddingX,
        top: top - upwardOffset,
        width: Math.max(1, width - paddingX * 2),
        height: Math.max(1, height - top - paddingY),
      };
    },
    updateMapResponsive(chart) {
      if (chart.getWidth() <= 0 || chart.getHeight() <= 0) return;
      const viewport = this.getMapViewport(chart);
      const model = chart.getModel();
      if (!model) return;
      const geo3DModel = model.getComponent("geo3D", 0);
      if (geo3DModel && geo3DModel.coordinateSystem) {
        const coordinateSystem = geo3DModel.coordinateSystem;
        const viewControl = geo3DModel.getModel("viewControl");
        const fitView = getMapFitView(
          coordinateSystem.size,
          viewport,
          viewControl.get("alpha"),
          viewControl.get("beta"),
          coordinateSystem.viewGL.camera.fov,
          this.mapFitPoints,
          this.currentLevel === "city"
        );
        const zoomRatio = this.mapFitDistance
          ? viewControl.get("distance") / this.mapFitDistance
          : 1;
        const currentCenter = viewControl.get("center") || [0, 0, 0];
        const center = fitView.center.map((value, index) => (
          value + currentCenter[index] - this.mapFitCenter[index]
        ));
        this.mapFitDistance = fitView.distance;
        this.mapFitCenter = fitView.center;
        chart.setOption({
          geo3D: {
            ...viewport,
            viewControl: {
              distance: fitView.distance * zoomRatio,
              center,
              maxDistance: Math.max(400, fitView.distance * 3),
            },
          },
        });
        return;
      }
      const geoModel = model.getComponent("geo", 0);
      if (geoModel && geoModel.coordinateSystem) {
        const coordinateSystem = geoModel.coordinateSystem;
        const bounds = coordinateSystem.getBoundingRect();
        const aspect = bounds.width / bounds.height * coordinateSystem.aspectScale;
        if (Number.isFinite(aspect) && aspect > 0) {
          chart.setOption({ geo: getMap2DLayout(viewport, aspect) });
        }
      }
    },
    hasWebGL() {
      try {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("webgl2") ||
          canvas.getContext("webgl") ||
          canvas.getContext("experimental-webgl");
        return Boolean(context);
      } catch (error) {
        return false;
      }
    },
    percentage(value, total) {
      if (!Number(total)) {
        return "0.00";
      }
      return ((Number(value) || 0) / Number(total) * 100).toFixed(2);
    },
    // KPI 数字滚动动画：从 0 平滑滚到目标值（easeOutCubic 缓动）
    animateKpi(targets, duration = 1200) {
      const startTime = performance.now();
      const step = (now) => {
        const progress = Math.min((now - startTime) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        Object.keys(targets).forEach((key) => {
          this.formData[key] = Math.round(targets[key] * eased);
        });
        if (progress < 1) {
          this.kpiRafId = requestAnimationFrame(step);
        } else {
          Object.keys(targets).forEach((key) => {
            this.formData[key] = targets[key];
          });
          this.kpiRafId = null;
        }
      };
      this.kpiRafId = requestAnimationFrame(step);
    },
    handleBreadcrumbClick(index) {
      if (this.currentLevel === "city" && index === 1) {
        this.backToProvince();
      }
    },
    openElevatorList(regionName) {
      this.elevatorListArea = regionName;
      this.elevatorListRows = MOCK_ELEVATOR_LIST.map((item) => ({ ...item }));
      this.resetElevatorList();
      this.elevatorListVisible = true;
      this.$nextTick(() => {
        if (this.$refs.elevatorListClose) {
          this.$refs.elevatorListClose.focus();
        }
      });
    },
    closeElevatorList() {
      this.closeElevatorMonitor();
      this.elevatorListVisible = false;
    },
    queryElevatorList() {
      this.elevatorListFilters = { ...this.elevatorListDraftFilters };
    },
    resetElevatorList() {
      const emptyFilters = { usageUnit: "", elevatorName: "" };
      this.elevatorListDraftFilters = { ...emptyFilters };
      this.elevatorListFilters = { ...emptyFilters };
    },
    viewElevatorData(item) {
      this.elevatorMonitorData = {
        ...MOCK_ELEVATOR_MONITOR,
        elevatorName: item.elevatorName,
        usageUnit: item.usageUnit,
        maintenanceUnit: item.maintenanceUnit,
        statistics: MOCK_ELEVATOR_MONITOR.statistics.map((statistic) => ({ ...statistic })),
      };
      this.elevatorMonitorVisible = true;
      this.$nextTick(() => {
        if (this.$refs.elevatorMonitorClose) {
          this.$refs.elevatorMonitorClose.focus();
        }
      });
    },
    closeElevatorMonitor() {
      this.elevatorMonitorVisible = false;
      this.elevatorMonitorData = null;
    },
    // join() {
    //   const wsuri = this.url;
    //   let that = this;
    //   this.webSocket = new WebSocket(wsuri);
    //   this.webSocket.onopen = function (event) {
    //     console.log("连接成功");
    //     that.text_content = that.text_content + "已经打开连接!" + "\n";
    //   };
    //   this.webSocket.onmessage = function (event) {
    //     if (that.first) {
    //       that.send();
    //       that.first = false;
    //     }
    //     //接收消息
    //     console.log("接收消息", event);
    //     that.text_content = event.data + "\n";
    //     //接收消息处理

    //     if (event.data !== "连接成功" && event.data !== "heart") {
    //       console.log(JSON.parse(event.data), "event.dataevent.data");
    //       that.realWarnList = [JSON.parse(event.data)];
    //       setInterval(() => {
    //         that.send();
    //       }, 10000);
    //     }
    //   };
    //   this.webSocket.onerror = function (error) {
    //     console.error("WebSocket 出错", error);
    //     that.join();
    //   };
    //   this.webSocket.onclose = function (event) {
    //     that.text_content = that.text_content + "已经关闭连接!" + "\n";
    //   };
    // },
    // exit() {
    //   if (this.webSocket) {
    //     this.webSocket.close();
    //     this.webSocket = null;
    //   }
    // },
    // send() {
    //   if (this.webSocket) {
    //     this.webSocket.send(localStorage.getItem("token"));
    //   } else {
    //     // alert("未连接到服务器");
    //   }
    // },
    getData() {
      this.loading = true;
      let loaded = 0;
      const done = () => {
        loaded += 1;
        if (loaded >= 2) {
          this.loading = false;
        }
      };
      getDataCenter().then((res) => {
        const data = res && res.data && typeof res.data === "object" && !Array.isArray(res.data)
          ? res.data
          : {};
        // KPI 数字滚动动画：从 0 平滑滚到目标值（数组字段在下面单独赋值）
        this.animateKpi({
          totalElevators: Number(data.totalElevators) || 0,
          iotElevators: Number(data.iotElevators) || 0,
          onlineElevators: Number(data.onlineElevators) || 0,
          offlineElevators: Number(data.offlineElevators) || 0,
          usageUnit: Number(data.usageUnit) || 0,
          daysRelieveNo: Number(data.daysRelieveNo) || 0,
          serviceNo: Number(data.serviceNo) || 0,
          dayNotNo: Number(data.dayNotNo) || 0,
        });
        this.thirtyFault = Array.isArray(data.elevatorFaultStatVos) ? data.elevatorFaultStatVos : [];
        this.thirtyWarnType = Array.isArray(data.elevatorTypeVos) ? data.elevatorTypeVos : [];
        this.sevenWarn = Array.isArray(data.sevenDayElevatorListVos) ? data.sevenDayElevatorListVos : [];
        this.thirtyWarnTime = Array.isArray(data.thirtyDaysElevatorListVos) ? data.thirtyDaysElevatorListVos : [];
        this.thirtyWarnUnit = Array.isArray(data.unitElevatorListVos) ? data.unitElevatorListVos : [];
        this.realWarnList = Array.isArray(data.wbElevatorListVos) ? data.wbElevatorListVos : [];

        this.unitTotal = 0;
        this.thirtyWarnUnit.map((item) => {
          this.unitTotal += Number(item.count);
        });
        this.$nextTick(() => {
          this.swiperInitUseUnit();
          // this.initMalfunction();
          this.initWarnType();
          // 图表错峰入场：依次出现更有节奏感
          setTimeout(() => this.initWarnTypeSeven(), 120);
          setTimeout(() => this.initWarnTime(), 240);
          this.swiperInitWarn(); // 等 DOM 更新完成再初始化 Swiper
        });
        done();
      }).catch(() => {
        this.formData = {
          ...this.formData,
          totalElevators: 0,
          iotElevators: 0,
          onlineElevators: 0,
          offlineElevators: 0,
          usageUnit: 0,
          daysRelieveNo: 0,
          serviceNo: 0,
          dayNotNo: 0,
        };
        this.thirtyFault = [];
        this.thirtyWarnType = [];
        this.sevenWarn = [];
        this.thirtyWarnTime = [];
        this.thirtyWarnUnit = [];
        this.realWarnList = [];
        this.unitTotal = 0;
        done();
      });
      getBoardData().then((res) => {
        const data = res && res.data && typeof res.data === "object" && !Array.isArray(res.data)
          ? res.data
          : {};
        this.boardForm = { ...this.boardForm, ...data };
        this.$nextTick(() => {
          this.initMalfunction();
        });
        done();
      }).catch(() => {
        this.boardForm = {
          threeYearsNumber: 0,
          twoYearsNumber: 0,
          sixYearsNumber: 0,
          nineYearsNumber: 0,
          twelveYearsNumber: 0,
          fifteenYearsNumber: 0,
        };
        done();
      });
    },
    initMap(mapName = "hubei", geoJson = hubeiGeoJson, mapTitle = "湖北省") {
      this.currentMapTitle = mapTitle;
      this.mapFitDistance = null;
      this.mapFitCenter = [0, 0, 0];
      this.mapFitPoints = Object.freeze([]);
      if (this.mapLabelUpdateTimer) {
        clearTimeout(this.mapLabelUpdateTimer);
        this.mapLabelUpdateTimer = null;
      }
      if (this.mapRotateTimer) {
        clearTimeout(this.mapRotateTimer);
        this.mapRotateTimer = null;
      }
      const mapElement = document.getElementById("map");
      const myChart = echarts.getInstanceByDom(mapElement) ||
        echarts.init(mapElement, null, {
          // 3D 地图为 WebGL 渲染，DPR 封顶 2，避免 4K/Retina 高分屏像素翻倍导致卡顿
          devicePixelRatio: Math.min(window.devicePixelRatio || 1, 2),
        });
      myChart.off("geo3dcamerachanged");
      this.myChart = myChart;
      echarts.registerMap(mapName, geoJson);
      const useMap3D = this.hasWebGL();
      const reduceMotion = window.matchMedia
        && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      const playIntroRotation = useMap3D && !reduceMotion && !document.hidden;
      this.mapLegend = [];

      const areaId = this.currentLevel === "province" ? "42" : areaNameMap[mapTitle] || mapTitle;
      this.mapRequestsPending += 1;
      getMapData({ areaId }).then((res) => {
        const mapList = res && Array.isArray(res.data) ? res.data : [];
        const mapData = mapDataToEcharts(mapList, geoJson);
        const pointData = mapDataToPoints(mapList, geoJson);
        const featureMap = (geoJson.features || []).reduce((features, feature) => {
          const properties = feature.properties || {};
          if (properties.name) {
            features[properties.name] = {
              properties,
              geometry: feature.geometry,
            };
          }
          return features;
        }, {});
        const getGeometryBounds = (coordinates, bounds = [Infinity, Infinity, -Infinity, -Infinity]) => {
          if (!Array.isArray(coordinates)) return bounds;
          if (typeof coordinates[0] === "number" && typeof coordinates[1] === "number") {
            bounds[0] = Math.min(bounds[0], coordinates[0]);
            bounds[1] = Math.min(bounds[1], coordinates[1]);
            bounds[2] = Math.max(bounds[2], coordinates[0]);
            bounds[3] = Math.max(bounds[3], coordinates[1]);
            return bounds;
          }
          coordinates.forEach((item) => getGeometryBounds(item, bounds));
          return bounds;
        };
        const mapBounds = (geoJson.features || []).reduce((bounds, feature) => (
          getGeometryBounds(feature.geometry && feature.geometry.coordinates, bounds)
        ), [Infinity, Infinity, -Infinity, -Infinity]);
        const mapWidth = Math.max(mapBounds[2] - mapBounds[0], 1);
        const mapHeight = Math.max(mapBounds[3] - mapBounds[1], 1);
        // 地名由 ECharts 放在区域包围盒中心。标点若距离该中心过近，则沿原方向轻微外移，
        // 既保留点位所属区域，又避免与地名直接叠在一起。
        const markerData = pointData.map((point, index) => {
          const feature = featureMap[point.name];
          const geometryBounds = getGeometryBounds(
            feature && feature.geometry && feature.geometry.coordinates
          );
          if (!feature || !Number.isFinite(geometryBounds[0])) return point;

          const labelX = (geometryBounds[0] + geometryBounds[2]) / 2;
          const labelY = (geometryBounds[1] + geometryBounds[3]) / 2;
          let deltaX = (Number(point.value[0]) - labelX) / mapWidth;
          let deltaY = (Number(point.value[1]) - labelY) / mapHeight;
          let distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
          // 约为地图可视宽度的 2.2%，足以避开文字，同时不会把小行政区的点推到边界外。
          const minimumDistance = 0.022;

          if (distance < minimumDistance) {
            if (distance < 0.002) {
              const directions = [[1, -0.75], [-1, -0.75], [1, 0.75], [-1, 0.75]];
              [deltaX, deltaY] = directions[index % directions.length];
              distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
            }
            const scale = minimumDistance / distance;
            return {
              ...point,
              value: [
                labelX + deltaX * scale * mapWidth,
                labelY + deltaY * scale * mapHeight,
                point.value[2],
              ],
            };
          }
          return point;
        });
        // geo3D 会先使用接口返回的区域，再按 GeoJSON 顺序补齐未返回数据的区域。
        // 热区使用同样的顺序，避免 3D 面事件的 dataIndex 映射到错误地名。
        const regionNames = [
          ...mapData.map((item) => item.name),
          ...(geoJson.features || []).map((feature) => (feature.properties || {}).name),
        ].filter((name, index, names) => name && names.indexOf(name) === index);
        const regionValueMap = mapData.reduce((values, item) => {
          const numericValue = Number(item.value);
          values[item.name] = Number.isFinite(numericValue) ? Math.round(numericValue) : 0;
          return values;
        }, {});
        // 依据电梯数量按图例区间填色；无数据区域保持深底。
        const regionMax = Math.max(0, ...Object.values(regionValueMap).map((v) => Number(v) || 0));
        const mapColorScale = createMapColorScale(regionMax);
        this.mapLegend = mapColorScale.legend;
        const regionStyleData = regionNames.map((name) => ({
          name,
          itemStyle: { color: mapColorScale.getColor(regionValueMap[name] || 0) },
        }));
        const regionData2D = mapData.map((item) => ({
          ...item,
          itemStyle: { areaColor: mapColorScale.getColor(item.value) },
        }));
        const regionClickData = regionNames.reduce((regions, regionName) => {
          const feature = featureMap[regionName];
          const properties = feature && feature.properties;
          const coordinates = properties && (properties.center || properties.centroid);
          if (Array.isArray(coordinates) && coordinates.length >= 2) {
            const elevatorCount = regionValueMap[regionName] || 0;
            regions.push({
              name: regionName,
              regionName,
              elevatorCount,
              value: [Number(coordinates[0]), Number(coordinates[1]), 0, elevatorCount],
            });
          }
          return regions;
        }, []);
        // 标点大小与数量成正比：2D 取 value[2]，3D 取 value[3]
        const markerMax = Math.max(...markerData.map((p) => Number(p.value[2]) || 0), 0);
        // 光柱标点：第三个维度（高度）随数量线性抬升，数量越大柱顶光点越高
        const point3DData = markerData.map((point) => {
          const count = Math.round(Number(point.value[2]) || 0);
          const height = markerMax > 0 ? 1 + (count / markerMax) * 2.5 : 1;
          return {
            name: point.name,
            value: [point.value[0], point.value[1], height, count],
            elevatorCount: count,
          };
        });
        // geo3D 会根据散点的第三维创建高度轴。这个不可见基准点用于建立高度范围，
        // 让真实点位始终位于地图表面之上，避免地图面抢走点位的鼠标事件。
        point3DData.push({
          name: "",
          value: [0, 0, 0, 0],
          elevatorCount: 0,
          symbolSize: 0,
          itemStyle: { opacity: 0 },
        });
        // bar3D 光柱与散点共用同一套高度值，柱底贴在地图顶面、柱顶落在散点正下方，
        // 形成「光柱 + 顶部亮点」的立体标点。
        const bar3DData = point3DData
          .filter((point) => point.name)
          .map((point) => ({
            name: point.name,
            elevatorCount: point.elevatorCount,
            value: [point.value[0], point.value[1], point.value[2]],
          }));
        const pointMax = Math.max(...point3DData.map((p) => Number(p.value[3]) || 0), 0);
        const normalizeMapValue = (rawValue) => {
          const value = Array.isArray(rawValue)
            ? (rawValue[3] !== undefined ? rawValue[3] : rawValue[2])
            : rawValue;
          const numericValue = Number(value);
          return Number.isFinite(numericValue) ? Math.round(numericValue) : 0;
        };
        const formatMapTooltip = (params) => {
          const data = params && params.data;
          const value = data && data.elevatorCount !== undefined
            ? normalizeMapValue(data.elevatorCount)
            : normalizeMapValue(params && params.value);
          const name = (params && params.name) || (data && data.name) || "当前区域";
          return value > 0 ? `${name}<br/>电梯数量：${value} 台` : name;
        };
        const mapRegionLabelRich = {
          name: {
            color: "#ECF8FF",
            fontSize: 13,
            fontWeight: "normal",
            lineHeight: 18,
            textBorderColor: "#031621",
            textBorderWidth: 2,
          },
          count: {
            color: "#7FF3FF",
            fontSize: 12,
            fontWeight: "bold",
            fontFamily: "Arial, Microsoft YaHei, sans-serif",
            padding: [0, 0, 0, 4],
            textBorderColor: "#031621",
            textBorderWidth: 2,
          },
        };
        const mapRegionLabelRichEmphasis = {
          name: {
            color: "#FFFFFF",
            fontSize: 14,
            fontWeight: "bold",
            lineHeight: 19,
            textBorderColor: "#031621",
            textBorderWidth: 2,
          },
          count: {
            color: "#FFF176",
            fontSize: 13,
            fontWeight: "bold",
            fontFamily: "Arial, Microsoft YaHei, sans-serif",
            padding: [0, 0, 0, 4],
            textBorderColor: "#031621",
            textBorderWidth: 2,
          },
        };
        const formatRegionLabel = (params) => {
          const name = (params && params.name) || "";
          const count = regionValueMap[name] || 0;
          return count > 0
            ? `{name|${name}}{count| ${count}}`
            : `{name|${name || " "}}`;
        };
        const getMapRegionName = (params) => {
          if (!params) return "";
          if (params.name && params.name !== mapTitle) return params.name;
          if (params.data && params.data.name && params.data.name !== mapTitle) {
            return params.data.name;
          }

          const dataIndex = Number(params.dataIndex);
          const seriesIndex = Number(params.seriesIndex);
          if (Number.isInteger(dataIndex) && dataIndex >= 0 && Number.isInteger(seriesIndex)) {
            const seriesModel = myChart.getModel().getSeriesByIndex(seriesIndex);
            const seriesData = seriesModel && seriesModel.getData();
            const seriesName = seriesData && seriesData.getName(dataIndex);
            if (seriesName) return seriesName;
          }

          const feature = geoJson && geoJson.features && geoJson.features[dataIndex];
          return feature && feature.properties ? feature.properties.name : "";
        };
        const mapViewport = this.getMapViewport(myChart);
        const rawMapAspect = (mapBounds[2] - mapBounds[0]) / (mapBounds[3] - mapBounds[1]) * 0.75;
        const mapAspect = Number.isFinite(rawMapAspect) && rawMapAspect > 0 ? rawMapAspect : 1;
        const geoWidth = Math.max(mapBounds[2] - mapBounds[0], 0.000001);
        const geoHeight = Math.max(mapBounds[3] - mapBounds[1], 0.000001);
        const mapFitPoints = [];
        const toMapFitPoint = (longitude, latitude, height) => [
          ((longitude - mapBounds[0]) / geoWidth - 0.5) * 110,
          height,
          (0.5 - (latitude - mapBounds[1]) / geoHeight) * 110 / mapAspect,
        ];
        const collectMapFitPoints = (coordinates) => {
          if (!Array.isArray(coordinates)) return;
          if (typeof coordinates[0] === "number" && typeof coordinates[1] === "number") {
            mapFitPoints.push(
              toMapFitPoint(coordinates[0], coordinates[1], 0),
              toMapFitPoint(coordinates[0], coordinates[1], 4.5)
            );
            return;
          }
          coordinates.forEach(collectMapFitPoints);
        };
        (geoJson.features || []).forEach((feature) => {
          collectMapFitPoints(feature.geometry && feature.geometry.coordinates);
        });
        markerData.forEach((point) => {
          mapFitPoints.push(toMapFitPoint(point.value[0], point.value[1], 11));
        });
        this.mapFitPoints = Object.freeze(mapFitPoints);
        const mapFitView = getMapFitView(
          [110, 11, 110 / mapAspect], mapViewport, 46, 0, 50, this.mapFitPoints,
          this.currentLevel === "city"
        );
        this.mapFitDistance = useMap3D ? mapFitView.distance : null;
        this.mapFitCenter = useMap3D ? mapFitView.center : [0, 0, 0];
        const option2D = {
          title: {
            text: mapTitle,
            left: "center",
            textStyle: {
              color: "#fff",
              fontSize: 18,
              fontWeight: "bold",
            },
          },
          tooltip: {
            trigger: "item",
            formatter: formatMapTooltip,
          },
          geo: {
            map: mapName,
            ...getMap2DLayout(mapViewport, mapAspect),
            // 保留拖动和手动缩放，初始地图按可用视口完整适配。
            roam: true,
            scaleLimit: { min: 0.85, max: 1.8 },
            zoom: 1,
            label: {
              show: true,
              formatter: "{b}",
              color: "#F2FBFF",
              fontSize: 12,
              fontWeight: "bold",
              textBorderColor: "#031621",
              textBorderWidth: 2,
            },
            itemStyle: {
              areaColor: "#0B2E46",
              borderColor: "#2B84A6",
            },
            emphasis: {
              label: {
                color: "#FFFFFF",
                textBorderColor: "#5C3A00",
                textBorderWidth: 2,
              },
              itemStyle: { areaColor: "#f0a31a" },
            },
          },
          series: [
            {
              name: mapTitle,
              type: "map",
              map: mapName,
              geoIndex: 0,
              roam: false,
              label: {
                show: true,
                formatter: "{b}",
                color: "#F2FBFF",
                fontSize: 12,
                fontWeight: "bold",
                textBorderColor: "#031621",
                textBorderWidth: 2,
              },
              itemStyle: {
                areaColor: "#0B2E46",
                borderColor: "#2B84A6",
              },
              emphasis: {
                label: {
                  show: true,
                  color: "#FFFFFF",
                  fontWeight: "bold",
                  textBorderColor: "#5C3A00",
                  textBorderWidth: 2,
                },
                itemStyle: { areaColor: "#f0a31a" },
              },
              data: regionData2D,
            },
            {
              name: "电梯数量",
              type: "effectScatter",
              coordinateSystem: "geo",
              geoIndex: 0,
              z: 3,
              data: markerData,
              symbolSize: (value) => mapPointSize(value, 2, markerMax, 11, 30),
              showEffectOn: "render",
              rippleEffect: {
                brushType: "stroke",
                scale: 3,
                period: 3,
              },
              itemStyle: {
                color: CHART.mapPoint,
                shadowBlur: 12,
                shadowColor: "rgba(255, 174, 0, 0.9)",
                borderColor: CHART.mapPointBorder,
                borderWidth: 2,
              },
              label: {
                show: true,
                formatter: (params) => {
                  const count = params && params.value && Math.round(Number(params.value[2]));
                  return count > 0 ? String(count) : "";
                },
                color: "#ffffff",
                fontSize: 11,
                fontWeight: "bold",
                textBorderColor: "#082638",
                textBorderWidth: 2,
                position: "top",
              },
              emphasis: {
                scale: 1.2,
                label: { show: true },
              },
              tooltip: {
                formatter: formatMapTooltip,
              },
            },
          ],
        };
        const option3D = {
          backgroundColor: "transparent",
          title: {
            show: false,
            text: mapTitle,
            left: "center",
            top: 8,
            textStyle: {
              color: "#fff",
              fontSize: 18,
              fontWeight: "bold",
              textShadowColor: "rgba(0, 229, 255, 0.75)",
              textShadowBlur: 8,
            },
          },
          tooltip: {
            trigger: "item",
            backgroundColor: "rgba(4, 24, 40, 0.94)",
            borderColor: "#2B8499",
            borderWidth: 1,
            textStyle: {
              color: "#D9F0F1",
              fontSize: 14,
            },
            formatter: (params) => {
              const count = params.data && params.data.elevatorCount !== undefined
                ? params.data.elevatorCount
                : normalizeMapValue(params.value);
              const name = params.name || (params.data && params.data.name) || "当前区域";
              return normalizeMapValue(count) > 0
                ? `${name}<br/>电梯数量：${normalizeMapValue(count)} 台`
                : name;
            },
          },
          geo3D: {
            // 地图和标点共用同一个可见坐标系，保证点位与地图位置一致。
            show: true,
            map: mapName,
            ...mapViewport,
            regions: regionStyleData,
            // 增加地图本体厚度，并用更低的俯视角露出侧面，避免看起来像带薄边的平面图。
            regionHeight: 4.5,
            boxWidth: 110,
            boxDepth: "auto",
            // 光柱的可用高度 = boxHeight - regionHeight；给足垂直空间让光柱立起来，
            // 同时控制上限，避免透视投影把高柱顶推到相邻行政区的视觉范围内。
            boxHeight: 11,
            shading: "color",
            // 关闭天空盒，让透明 WebGL 画布直接透出大屏背景。
            environment: "none",
            light: {
              main: {
                intensity: 1.7,
                alpha: 38,
                beta: -25,
                shadow: false,
              },
              ambient: {
                intensity: 0.48,
              },
            },
            // 关闭后处理，避免 SSAO/纹理重采样让 3D 地名发虚，也避免线性色彩空间把地图颜色带灰。
            // 地图的立体层次由挤出高度、方向光和侧面明暗提供。
            postEffect: {
              enable: false,
            },
            viewControl: {
              projection: "perspective",
              alpha: 46,
              beta: 0,
              distance: mapFitView.distance,
              center: mapFitView.center,
              maxDistance: Math.max(400, mapFitView.distance * 3),
              minAlpha: 40,
              maxAlpha: 65,
              minBeta: -12,
              maxBeta: 12,
              autoRotate: playIntroRotation,
              autoRotateSpeed: 1.2,
              rotateSensitivity: 0,
              zoomSensitivity: 1,
              panSensitivity: 1,
            },
            label: {
              show: true,
              formatter: formatRegionLabel,
              // geo3D 会自动把标签放到 regionHeight 顶面；额外高度在透视下会造成地名向上漂移。
              distance: 0,
              // 地名是主层，数量使用较小的亮色层，避免两者争抢视觉焦点。
              opacity: 1,
              fontFamily: "Microsoft YaHei, Arial, sans-serif",
              rich: mapRegionLabelRich,
            },
            itemStyle: {
              color: "#123A52",
              borderColor: "#2A86A6",
              borderWidth: 0.8,
              opacity: 1,
            },
            emphasis: {
              label: {
                show: true,
                formatter: formatRegionLabel,
                fontFamily: "Microsoft YaHei, Arial, sans-serif",
                rich: mapRegionLabelRichEmphasis,
              },
              itemStyle: {
                color: "#1E5572",
                borderColor: "#9AC4C8",
              },
            },
          },
          series: [
            {
              name: "区域下钻",
              type: "scatter3D",
              coordinateSystem: "geo3D",
              geo3DIndex: 0,
              data: regionClickData,
              symbolSize: 32,
              itemStyle: {
                opacity: 0,
              },
              label: {
                show: false,
              },
              tooltip: {
                show: true,
                formatter: formatMapTooltip,
              },
            },
            {
              name: "电梯光柱",
              type: "bar3D",
              coordinateSystem: "geo3D",
              geo3DIndex: 0,
              data: bar3DData,
              // 柱子宽深（世界单位）；地图宽约 110，2.8 约 2.5% 宽，呈细长光柱。
              barSize: 2.8,
              // lambert 让柱身在方向光下产生明暗面，比纯色更接近发光实体。
              shading: "lambert",
              itemStyle: {
                color: "#00D4FF",
                opacity: 0.55,
              },
              emphasis: {
                itemStyle: {
                  color: "#7FF3FF",
                  opacity: 0.9,
                },
              },
              tooltip: {
                show: true,
                formatter: formatMapTooltip,
              },
            },
            {
              name: "电梯数量",
              type: "scatter3D",
              coordinateSystem: "geo3D",
              geo3DIndex: 0,
              data: point3DData,
              symbolSize: (value) => mapPointSize(value, 3, pointMax, 8, 16),
              blendMode: "lighter",
              itemStyle: {
                color: CHART.mapPoint,
                opacity: 1,
                borderColor: CHART.mapPointBorder,
                borderWidth: 2,
              },
              label: {
                show: false,
              },
              emphasis: {
                scale: 1.3,
                itemStyle: {
                  color: "#FFF176",
                  opacity: 1,
                },
                label: {
                  show: false,
                },
              },
              tooltip: {
                show: true,
                formatter: formatMapTooltip,
              },
            },
          ],
        };
        const option = useMap3D ? option3D : option2D;

        myChart.setOption(option, true);
        if (useMap3D) {
          let activeMapLabelStyleKey = "13-12-14-13";
          const updateMapLabelsForZoom = (params) => {
            const distance = Number(params && params.distance);
            if (!Number.isFinite(distance) || distance <= 0) return;

            const scale = getMapLabelScale(distance, this.mapFitDistance || MAP_LABEL_BASE_DISTANCE);
            const labelRich = scaleMapLabelRich(mapRegionLabelRich, scale);
            const emphasisLabelRich = scaleMapLabelRich(mapRegionLabelRichEmphasis, scale);
            const styleKey = [
              labelRich.name.fontSize,
              labelRich.count.fontSize,
              emphasisLabelRich.name.fontSize,
              emphasisLabelRich.count.fontSize,
            ].join("-");

            if (this.mapLabelUpdateTimer) {
              clearTimeout(this.mapLabelUpdateTimer);
              this.mapLabelUpdateTimer = null;
            }
            if (styleKey === activeMapLabelStyleKey) return;

            this.mapLabelUpdateTimer = setTimeout(() => {
              this.mapLabelUpdateTimer = null;
              if (myChart.isDisposed()) return;

              activeMapLabelStyleKey = styleKey;
              myChart.setOption({
                geo3D: {
                  label: { rich: labelRich },
                  emphasis: { label: { rich: emphasisLabelRich } },
                },
              });
            }, 120);
          };
          myChart.on("geo3dcamerachanged", updateMapLabelsForZoom);

          // echarts-gl 的 geo3D 面没有 seriesIndex，默认不会派发下钻事件。
          // 将其绑定到透明下钻系列，使鼠标点击地图任意区域都能进入市级地图。
          const geo3DModel = myChart.getModel().getComponent("geo3D", 0);
          if (geo3DModel) {
            geo3DModel.seriesIndex = 0;
            const geo3DView = myChart.getViewOfComponentModel(geo3DModel);
            const polygonMesh = geo3DView && geo3DView._geo3DBuilder
              && geo3DView._geo3DBuilder._polygonMesh;
            if (polygonMesh) polygonMesh.seriesIndex = 0;
          }
          if (playIntroRotation) {
            this.mapRotateTimer = setTimeout(() => {
              if (!myChart.isDisposed()) {
                myChart.setOption({
                  geo3D: { viewControl: { autoRotate: false } },
                });
              }
              this.mapRotateTimer = null;
            }, 6000);
          }
        }
        myChart.off("click");
        myChart.on("click", (params) => {
          const isMapRegion = params.seriesType === "map"
            || params.seriesType === "map3D"
            || params.seriesType === "scatter3D"
            || params.seriesType === "bar3D"
            || params.componentType === "geo3D";
          if (!isMapRegion) return;

          const regionName = getMapRegionName(params);
          if (!regionName) return;

          if (this.currentLevel === "province") {
            this.loadCityMap(regionName);
            return;
          }

          const regionValue = regionValueMap[regionName]
            || (params.data && Number(params.data.elevatorCount))
            || 0;
          if (this.currentLevel === "city" && regionValue > 0) {
            this.openElevatorList(regionName);
          }
        });
      }).catch(() => {
        this.mapLegend = [];
        myChart.setOption({
          title: {
            text: mapTitle,
            left: "center",
            textStyle: { color: "#fff", fontSize: 18, fontWeight: "bold" },
          },
          geo: {
            map: mapName,
            roam: true,
            scaleLimit: { min: 0.85, max: 1.8 },
            zoom: 1,
            label: {
              show: true,
              color: "#C9E6F0",
              fontSize: 12,
              textBorderColor: "#07222F",
              textBorderWidth: 1,
            },
            itemStyle: { areaColor: "#0B2E46", borderColor: "#2B84A6" },
          },
          series: [{
            name: mapTitle,
            type: "map",
            map: mapName,
            geoIndex: 0,
            roam: false,
            label: {
              show: true,
              color: "#C9E6F0",
              fontSize: 12,
              textBorderColor: "#07222F",
              textBorderWidth: 1,
            },
            itemStyle: { areaColor: "#0B2E46", borderColor: "#2B84A6" },
            data: [],
          }],
        }, true);
        this.mapFitDistance = null;
        this.updateMapResponsive(myChart);
      }).finally(() => {
        this.mapHasLoaded = true;
        this.mapRequestsPending = Math.max(0, this.mapRequestsPending - 1);
      });
    },
    loadCityMap(cityName) {
      // 市名转拼音映射（示例，建议完善）
      const cityMap = {
        十堰市: { mapName: "shiyan", geoJson: shiyan },
        神农架林区: { mapName: "shennongjia", geoJson: shennongjia },
        恩施土家族苗族自治州: { mapName: "enshi", geoJson: enshi },
        襄阳市: { mapName: "xiangyang", geoJson: xiangyang },
        宜昌市: { mapName: "yichang", geoJson: yichang },
        随州市: { mapName: "suizhou", geoJson: suizhou },
        荆门市: { mapName: "jingmen", geoJson: jingmen },
        荆州市: { mapName: "jingzhou", geoJson: jingzhou },
        孝感市: { mapName: "xiaogan", geoJson: xiaogan },
        天门市: { mapName: "tianmen", geoJson: tianmen },
        潜江市: { mapName: "qianjiang", geoJson: qianjiang },
        仙桃市: { mapName: "xiantao", geoJson: xiantao },
        武汉市: { mapName: "wuhan", geoJson: wuhan },
        黄冈市: { mapName: "huanggang", geoJson: huanggang },
        鄂州市: { mapName: "ezhou", geoJson: ezhou },
        黄石市: { mapName: "huangshi", geoJson: huangshi },
        咸宁市: { mapName: "xianning", geoJson: xianning },
        // 其他市对应json要补充
      };
      const city = cityMap[cityName];
      if (!city) {
        alert("未找到该市的地图数据！");
        return;
      }
      this.currentLevel = "city";
      this.currentMapName = city.mapName;
      this.initMap(city.mapName, city.geoJson, cityName); // 传入市区地图参数
    },
    backToProvince() {
      if (this.currentLevel === "city") {
        this.closeElevatorList();
        this.currentLevel = "province";
        this.currentMapName = "hubei";
        this.initMap("hubei", hubeiGeoJson, "湖北省");
      }
    },
    lookMask() {
      this.$refs.mask.open();
    },
    swiperInitUseUnit() {
      if (this.useUnitSwiper) {
        this.useUnitSwiper.destroy(true, true);
        this.useUnitSwiper = null;
      }

      const pageCount = this.rankedThirtyWarnUnitPages.length;
      if (pageCount <= 1) {
        return;
      }

      this.useUnitSwiper = new Swiper(".use_box", {
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: true,
        loopAdditionalSlides: pageCount,
        direction: "vertical", // 垂直切换选项
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        }, //可选选项，自动滑动
        speed: 700,
        spaceBetween: 0,
      });
    },
    swiperInitWarn() {
      if (this.realWarnSwiper) {
        this.realWarnSwiper.destroy(true, true);
        this.realWarnSwiper = null;
      }

      const pageCount = this.rankedRealWarnPages.length;
      if (pageCount <= 1) {
        return;
      }

      this.realWarnSwiper = new Swiper(".real_box", {
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: true,
        loopAdditionalSlides: pageCount,
        direction: "vertical", // 垂直切换选项
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        }, //可选选项，自动滑动
        speed: 700,
        spaceBetween: 0,
      });
    },

    initWarnToday() {
      const element = document.getElementById("warnToday");
      if (!element) return;
      const charts = echarts.getInstanceByDom(element) || echarts.init(element);
      const hasData = this.todayTypeChartData.some((item) => Number(item.value) > 0);
      const option = {
        animation: false,
        tooltip: {
          show: hasData,
          trigger: "item",
          appendTo: "body",
          backgroundColor: "rgba(5, 25, 43, 0.96)",
          borderColor: "rgba(0, 212, 255, 0.3)",
          textStyle: { color: "#e1edf5" },
          formatter: "{b}：{c} ({d}%)",
        },
        series: [
          {
            name: "告警类型",
            type: "pie",
            radius: ["63%", "80%"],
            center: ["50%", "50%"],
            avoidLabelOverlap: false,
            stillShowZeroSum: false,
            showEmptyCircle: true,
            emptyCircleStyle: {
              color: "rgba(71, 117, 143, 0.28)",
            },
            itemStyle: {
              borderColor: "rgba(3, 20, 35, 0.92)",
              borderWidth: 2,
            },
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            emphasis: {
              scale: false,
            },
            data: hasData ? this.todayTypeChartData : [],
          },
        ],
      };
      charts.setOption(option);
    },
    updateWarnTypeResponsive(chart) {
      if (!chart || chart.isDisposed()) return;

      const chartWidth = chart.getWidth();
      const option = chart.getOption();
      const xAxis = option.xAxis && option.xAxis[0];
      const categoryCount = xAxis && Array.isArray(xAxis.data) ? xAxis.data.length : 0;
      const isCompact = chartWidth < 620;
      const isNarrow = chartWidth < 340;
      const visibleLabelCount = isCompact
        ? Math.max(4, Math.floor(chartWidth / 92))
        : categoryCount;
      const labelStep = Math.max(1, Math.ceil(categoryCount / visibleLabelCount));
      const labelWidth = isCompact
        ? Math.max(48, Math.floor((chartWidth - 56) / Math.min(visibleLabelCount, categoryCount || 1)) - 8)
        : undefined;
      chart.setOption({
        grid: {
          top: isCompact ? 40 : 50,
          left: 48,
          right: 24,
          bottom: isCompact ? 28 : 20,
          containLabel: false,
        },
        xAxis: {
          axisLabel: {
            color: "#fff",
            fontSize: isNarrow ? 9 : isCompact ? 10 : 8,
            rotate: 0,
            interval: isCompact
              ? (index) => index === 0 || index === categoryCount - 1 || index % labelStep === 0
              : 0,
            hideOverlap: true,
            showMinLabel: true,
            showMaxLabel: true,
            width: labelWidth,
            overflow: isCompact ? "truncate" : undefined,
            ellipsis: "…",
            margin: isCompact ? 5 : undefined,
            formatter: isCompact
              ? (value) => {
                const label = String(value || "");
                return label.length > 6 ? `${label.slice(0, 6)}…` : label;
              }
              : undefined,
          },
        },
        yAxis: {
          name: isCompact ? "" : "单位：次",
          axisLabel: {
            color: "#fff",
            fontSize: isCompact ? 10 : 12,
            margin: isCompact ? 4 : undefined,
            hideOverlap: true,
          },
          splitNumber: isCompact ? 3 : undefined,
        },
        series: [{
          barWidth: isCompact ? "48%" : 20,
          barMaxWidth: isCompact ? 18 : 20,
        }],
      }, false);
    },
    updateTrendResponsive(chart, chartType) {
      if (!chart || chart.isDisposed()) return;

      const chartWidth = chart.getWidth();
      const option = chart.getOption();
      const xAxis = option.xAxis && option.xAxis[0];
      const categoryCount = xAxis && Array.isArray(xAxis.data) ? xAxis.data.length : 0;
      const isCompact = chartWidth < 760;
      const visibleLabelCount = isCompact ? Math.max(5, Math.floor(chartWidth / 110)) : categoryCount;
      const labelStep = Math.max(1, Math.ceil(categoryCount / visibleLabelCount));

      chart.setOption({
        grid: {
          top: isCompact ? 40 : 50,
          left: 48,
          right: 24,
          bottom: isCompact ? 28 : 30,
          containLabel: false,
        },
        xAxis: {
          axisLabel: {
            color: "#fff",
            fontSize: isCompact ? 10 : 12,
            rotate: 0,
            interval: isCompact
              ? (index) => index === 0 || index === categoryCount - 1 || index % labelStep === 0
              : 0,
            hideOverlap: true,
            showMinLabel: true,
            showMaxLabel: true,
            margin: isCompact ? 6 : undefined,
            formatter: isCompact
              ? (value) => {
                const label = String(value || "");
                return label.length > 8 ? `${label.slice(0, 8)}…` : label;
              }
              : undefined,
          },
        },
        yAxis: {
          axisLabel: {
            color: "#fff",
            fontSize: isCompact ? 10 : 12,
            margin: isCompact ? 4 : undefined,
            hideOverlap: true,
          },
          splitNumber: isCompact ? 3 : undefined,
        },
        series: [chartType === "line"
          ? {
            symbolSize: isCompact ? 6 : 8,
          }
          : {
            barWidth: isCompact ? 14 : 20,
            barMaxWidth: isCompact ? 16 : 20,
          }],
      }, false);
    },
    initWarnTime() {
      const xData = this.thirtyWarnTime.map((item) => {
        return item.faultType;
      });
      const yData = this.thirtyWarnTime.map((item) => {
        return item.count;
      });
      const charts = echarts.init(document.getElementById("warnTime"));
      const option = {
        backgroundColor: "transparent",
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: 50,
          left: 40,
          right: 10,
          bottom: 30,
        },
        xAxis: {
          type: "category",
          data: xData,
          axisLabel: {
            color: "#fff",
          },
          axisLine: {
            lineStyle: {
              color: "#3A4F66",
            },
          },
        },
        yAxis: {
          name: "单位：次",
          type: "value",
          axisLabel: {
            color: "#fff",
          },
          splitLine: {
            lineStyle: {
              color: "#3A4F66",
              type: "dashed",
            },
          },
          nameTextStyle: {
            color: "#fff",
          },
        },
        series: [
          {
            name: "数量",
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 8,
            data: yData,
            lineStyle: {
              color: CHART.line, //折线颜色
            },
            itemStyle: {
              color: CHART.line, //折点颜色
              borderColor: "#fff",
              borderWidth: 1,
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(255,179,0,0.35)" },
                { offset: 1, color: "rgba(255,179,0,0)" },
              ]),
            },
          },
        ],
      };
      charts.setOption(option);
      this.updateTrendResponsive(charts, "line");
    },
    initWarnTypeSeven() {
      const data = this.sevenWarn.map((item) => {
        return {
          name: item.faultType,
          value: item.count,
        };
      });
      const xData = data.map((item) => item.name);
      const yData = data.map((item) => item.value);
      const charts = echarts.init(document.getElementById("warnTypeSeven"));
      const option = {
        backgroundColor: "transparent",
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          top: 50,
          left: 10,
          right: 20,
          bottom: 20,
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: xData,
          axisLabel: {
            color: "#fff",
            fontSize: 12,
          },
          axisLine: {
            lineStyle: {
              color: "#3A4F66",
            },
          },
        },
        yAxis: {
          name: "单位：%",
          type: "value",
          axisLabel: {
            color: "#fff",
            fontSize: 12,
          },
          splitLine: {
            lineStyle: {
              color: "#3A4F66",
              type: "dashed",
            },
          },
          nameTextStyle: {
            color: "#fff",
            padding: [0, 0, 0, 0],
          },
        },
        series: [
          {
            // name: "%",
            type: "bar",
            barWidth: 20,
            data: yData,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, CHART.barGradient),
            },
          },
        ],
      };
      charts.setOption(option);
      this.updateTrendResponsive(charts, "bar");
    },
    initWarnType() {
      const data = this.thirtyWarnType.map((item) => {
        return {
          name: item.faultType,
          value: item.count,
        };
      });
      const xData = data.map((item) => item.name);
      const yData = data.map((item) => item.value);
      const charts = echarts.init(document.getElementById("warnTypeThirty"));
      const option = {
        backgroundColor: "transparent",
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          top: 50,
          left: 40,
          right: 20,
          bottom: 20,
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: xData,
          axisLabel: {
            color: "#fff",
            fontSize: 8,
            align: "center", // 文字水平居中
            rotate: 14, // 文字旋转角度
          },
          axisLine: {
            lineStyle: {
              color: "#3A4F66",
            },
          },
        },
        yAxis: {
          name: "单位：次",
          type: "value",
          axisLabel: {
            color: "#fff",
            fontSize: 12,
          },
          splitLine: {
            lineStyle: {
              color: "#3A4F66",
              type: "dashed",
            },
          },
          nameTextStyle: {
            color: "#fff",
            padding: [0, 0, 0, 0],
          },
        },
        series: [
          {
            name: "次数",
            type: "bar",
            barWidth: 20,
            data: yData,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, CHART.barGradient),
            },
          },
        ],
      };
      charts.setOption(option);
      this.updateWarnTypeResponsive(charts);
    },
    initMalfunction() {
      const data = [
        { name: "3年以下", value: this.boardForm.threeYearsNumber },
        { name: "3-6年", value: this.boardForm.twoYearsNumber },
        { name: "6-9年", value: this.boardForm.sixYearsNumber },
        { name: "9-12年", value: this.boardForm.nineYearsNumber },
        { name: "12-15年", value: this.boardForm.twelveYearsNumber },
        { name: "15年以上", value: this.boardForm.fifteenYearsNumber },
      ];
      const total = data.reduce((sum, item) => sum + item.value, 0) || 1;
      const colors = CHART.palette;
      const charts = echarts.init(document.getElementById("malfunction"));
      const option = {
        tooltip: {
          trigger: "item",
          formatter: "{b}：{c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          right: 10,
          top: 20,
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            color: "#fff",
            fontSize: 12,
          },
          formatter: (name) => {
            const item = data.find((d) => d.name === name);
            const percent = ((item.value / total) * 100).toFixed(2);
            return `${name}  ${item.value} (${percent}%)`;
          },
        },
        series: [
          {
            name: "告警类型",
            type: "pie",
            radius: ["50%", "70%"],
            center: ["30%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            color: colors,
            data,
          },
        ],
      };
      charts.setOption(option);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/viewport.scss";

.page_main {
  margin-top: vh(10);
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  column-gap: vw(12);
  .left {
    .general_box {
      width: 100%;
      .general_content {
        height: vh(240);
        padding: vh(18) vw(20);
        display: flex;
        align-items: center;
        .item_box {
          flex: 1;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          .item_list {
            height: vh(50);
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            .icon {
              height: 100%;
              width: vw(64);
            }
            .list_desc {
              height: 100%;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              justify-content: center;
              margin-left: vw(10);
              .label {
                font-weight: 400;
                font-size: vw(14);
                color: #b8c6d3;
              }
              .num {
                font-family: $font-number;
                font-weight: 700;
                font-size: vw(22);
                color: #00d4ff;
                text-shadow: 0 0 12px rgba(0, 212, 255, 0.55);
                line-height: 1.2;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                width: vw(105);
                span {
                  font-size: vw(12);
                  color: #9fd8e8;
                  text-shadow: none;
                }
              }
            }
          }
        }
        .line {
          height: 100%;
          width: 1px;
          background: #00ffff;
          margin: auto vw(20);
        }
      }
    }
    .thirtydays_box {
      margin-top: vh(7);
      width: 100%;
      flex: 1;
      .thirtydays_content {
        height: calc(100% - vh(60));
        width: 100%;
        min-height: 0;
        overflow: hidden;
        position: relative;
      }
    }
  }
  .center {
    flex: 1 1 auto;
    width: auto;
    min-width: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    .map_box {
      width: 100%;
      flex: 1;
      position: relative;
      min-height: 0;
      display: flex;
      flex-direction: column;
      .map_breadcrumb {
        position: absolute;
        top: vh(112);
        left: vw(20);
        z-index: 6;
        display: flex;
        align-items: center;
        height: vh(28);
        line-height: 1;
        color: #eefaff;
        font-size: vw(14);
        letter-spacing: vw(0.5);
        text-shadow: 0 0 8px rgba(0, 212, 255, 0.45);
        white-space: nowrap;
        .map_breadcrumb_part {
          display: inline-flex;
          align-items: center;
          height: 100%;
        }
        .map_breadcrumb_separator {
          margin: 0 vw(8);
          color: #5ab8d3;
        }
        .map_breadcrumb_link,
        .map_breadcrumb_active {
          display: inline-flex;
          align-items: center;
          height: 100%;
          font: inherit;
          line-height: 1;
        }
        .map_breadcrumb_link {
          padding: 0;
          border: 0;
          color: #8bcfe2;
          background: transparent;
          cursor: pointer;
          pointer-events: auto;
          text-shadow: inherit;
          &:hover,
          &:focus-visible {
            color: #00eeff;
            outline: none;
            text-shadow: 0 0 10px rgba(0, 238, 255, 0.8);
          }
        }
        .map_breadcrumb_active {
          color: #00eeff;
          text-shadow: 0 0 10px rgba(0, 238, 255, 0.75);
        }
      }
      .map_content {
        width: 100%;
        flex: 1 1 auto;
        min-height: 0;
        background: transparent;
        cursor: grab;
        &:active {
          cursor: grabbing;
        }
      }
      .map_loading_overlay {
        position: absolute;
        z-index: 4;
        top: vh(100);
        right: 0;
        bottom: vh(48);
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        color: #a8d8e8;
        font-size: vw(13);
        text-shadow: 0 0 8px rgba(0, 212, 255, 0.45);
        background: rgba(2, 19, 34, 0.36);
        pointer-events: none;
        .map_loading_shape {
          position: absolute;
          width: 62%;
          height: 68%;
          opacity: 0.46;
          background: linear-gradient(100deg, rgba(13, 64, 94, 0.62) 25%, rgba(35, 122, 161, 0.56) 45%, rgba(13, 64, 94, 0.62) 65%);
          background-size: 220% 100%;
          animation: data-loading-shimmer 1.6s ease-in-out infinite;
          clip-path: polygon(25% 6%, 40% 3%, 50% 12%, 66% 15%, 78% 12%, 87% 25%, 94% 38%, 85% 51%, 90% 66%, 80% 77%, 70% 77%, 66% 94%, 53% 91%, 47% 79%, 34% 82%, 28% 67%, 12% 67%, 8% 51%, 17% 39%, 12% 25%, 23% 20%);
        }
        span {
          position: relative;
          z-index: 1;
          padding: vh(9) vw(14);
          border: 1px solid rgba(0, 212, 255, 0.28);
          background: rgba(3, 25, 43, 0.86);
        }
      }
      .map_legend {
        flex: 0 0 vh(38);
        box-sizing: border-box;
        width: calc(100% - vw(80));
        margin: 0 auto vh(8);
        padding: 0 vw(20);
        display: flex;
        align-items: center;
        justify-content: center;
        gap: vw(28);
        list-style: none;
        color: #d9f0f1;
        font-size: vw(12);
        .map_legend_item {
          display: flex;
          align-items: center;
          white-space: nowrap;
        }
        .map_legend_swatch {
          width: vw(28);
          height: vh(10);
          margin-right: vw(8);
          border: 1px solid rgba(154, 196, 200, 0.45);
          border-radius: 2px;
          box-shadow: 0 0 8px rgba(0, 212, 255, 0.18);
        }
        .map_legend_empty {
          color: #7fa1b3;
        }
      }
    }
    .center_bottom {
      width: 100%;
      display: flex;
      column-gap: vw(8);
      justify-content: flex-start;
      margin-top: vh(10);
      margin-bottom: 0;
      .charts_bottom_box {
        width: calc(50% - vw(4));
      }
    }
  }
  .right {
    .today_warn_box {
      width: 100%;
      .today_warn_content {
        height: vh(280);
        padding: vh(16) vw(18);
        display: grid;
        grid-template-rows: minmax(0, 1fr) auto;
        row-gap: vh(12);
        box-sizing: border-box;
        .today_type_distribution {
          display: grid;
          grid-template-columns: minmax(0, 0.43fr) minmax(0, 0.57fr);
          column-gap: vw(12);
          min-height: 0;
          align-items: center;
        }
        .today_charts {
          position: relative;
          width: 100%;
          height: 100%;
          min-width: 0;
          min-height: 0;
          .today_chart_canvas {
            width: 100%;
            height: 100%;
          }
          .center_num {
            max-width: 58%;
            .today_chart_title {
              color: #ecf8ff;
              font-size: clamp(11px, vw(14), 18px);
              font-weight: 400;
              line-height: 1.2;
              text-shadow: none;
              white-space: nowrap;
            }
          }
        }
        .today_type_legend {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: vh(12) vw(10);
          min-width: 0;
          margin: 0;
          padding: 0;
          list-style: none;
          li {
            display: flex;
            align-items: center;
            gap: vw(6);
            min-width: 0;
            color: #b8d4e2;
            font-size: clamp(10px, vw(12), 16px);
            line-height: 1.4;
          }
          .type_marker {
            flex: 0 0 auto;
            width: clamp(6px, vw(8), 10px);
            height: clamp(6px, vw(8), 10px);
            border: 1px solid rgba(127, 243, 255, 0.25);
            border-radius: 2px;
          }
          .type_name {
            min-width: 0;
            overflow-wrap: anywhere;
          }
        }
        .today_status_summary {
          padding-top: vh(10);
          border-top: 1px solid rgba(92, 155, 185, 0.2);
        }
        .today_status_title {
          margin-bottom: vh(6);
          color: #94b6c8;
          font-size: clamp(10px, vw(11), 15px);
          font-weight: 400;
          line-height: 1.4;
        }
        .today_legend {
          width: 100%;
          min-width: 0;
          margin: 0;
          padding: 0;
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: vw(8);
          .legend_list {
            min-width: 0;
            min-height: vh(58);
            box-sizing: border-box;
            padding: vh(7) vw(8);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: vh(5);
            border: 1px solid transparent;
            color: $color-info;
            & + .legend_list {
              border-left-color: rgba(92, 155, 185, 0.16);
            }
            &.success {
              color: $color-success;
            }
            &.warn {
              color: $color-warning;
            }
            &.danger {
              color: #ff5f4a;
              border-color: rgba(255, 95, 74, 0.18);
              background: linear-gradient(90deg, rgba(255, 95, 74, 0.12), rgba(255, 95, 74, 0.02));
              .status {
                color: #ffc0b4;
              }
              .value {
                font-size: vw(32);
              }
            }
            &.is_empty {
              .status {
                color: #95adbd;
              }
              .value {
                color: #819aaa;
              }
              .status_marker {
                opacity: 0.6;
              }
              &.danger {
                border-color: transparent;
                border-left-color: rgba(92, 155, 185, 0.16);
                background: none;
                .value {
                  font-size: vw(26);
                }
              }
            }
            .status_marker {
              flex: 0 0 vw(6);
              width: vw(6);
              height: vw(6);
              margin-right: vw(6);
              border-radius: 50%;
              background: currentColor;
            }
            .status {
              display: flex;
              align-items: center;
              min-width: 0;
              color: $color-text-sub;
              font-weight: 400;
              font-size: clamp(10px, vw(12), 16px);
              line-height: 1.2;
            }
            .status_label {
              min-width: 0;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .value {
              flex: 0 0 auto;
              margin: 0;
              width: auto;
              height: auto;
              color: currentColor;
              font-family: $font-number;
              font-size: vw(26);
              font-variant-numeric: tabular-nums;
              font-weight: 700;
              line-height: 1;
            }
          }
        }
      }
    }
    .real_time {
      width: 100%;
      flex: 1;
      overflow: hidden;
      margin-top: vh(7);
      margin-bottom: vh(5);

      .real_content {
        height: calc(100% - vh(42));
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        .real_box {
          height: calc(100% - vh(20));
          width: calc(100% - vw(40));
          margin: 0 auto;
          overflow: hidden;
          position: relative;

          &.empty_state {
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .real_page {
            height: 100%;
            width: 100%;
            display: flex;
            flex-direction: column;
          }

          .real_list {
            height: 25%;
            flex: 0 0 25%;
            display: flex;
            width: 100%;
            box-sizing: border-box;
            padding: vh(4) 0;

            .rank_item {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
    .use_box {
      overflow: hidden;
      position: relative;
      box-sizing: border-box;
      padding: vh(6) vw(20);

      .swiper-wrapper {
        height: 100%;
      }

      .unit_page {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
      }

      .unit_list {
        height: 33.3333%;
        flex: 0 0 33.3333%;
        box-sizing: border-box;
        padding: vh(3) 0;

        .sort_item {
          width: 100%;
          height: 100%;
          padding-top: vh(3);
          padding-bottom: vh(3);

          .process_box {
            margin-top: vh(3);
          }
        }
      }
    }
    .rank_item,
    .sort_item {
      min-width: 0;
      box-sizing: border-box;
      padding: vh(6) vw(12);
      display: flex;
      flex-direction: column;
      justify-content: center;
      border: 1px solid rgba(0, 187, 255, 0.16);
      border-radius: 2px;
      background: linear-gradient(90deg, rgba(8, 85, 150, 0.42), rgba(8, 55, 98, 0.24));
      box-shadow: inset 0 0 14px rgba(0, 171, 250, 0.08);

      .rank_info,
      .sort_info {
        min-width: 0;
        display: flex;
        align-items: center;
      }

      .rank_badge {
        flex: 0 0 vw(52);
        min-width: 0;
        display: inline-flex;
        align-items: center;
        gap: vw(4);
        color: #9fd8e8;
        white-space: nowrap;

        .icon {
          width: vw(16);
          height: vw(16);
          flex: none;
        }

        .rank_order {
          font-family: $font-number;
          font-size: vw(11);
          line-height: 1;
        }
      }

      .sort {
        min-width: 0;
        flex: 1;
        margin-right: vw(8);
        font-weight: 700;
        font-size: vw(12);
        color: #fff;
        text-align: left;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .value {
        min-width: vw(30);
        flex: none;
        font-family: $font-number;
        font-weight: 700;
        font-size: vw(14);
        color: #00abfa;
        line-height: 1;
        text-align: right;
        text-shadow: 0 0 8px rgba(0, 171, 250, 0.35);

        &.first {
          color: #ff9900;
          text-shadow: 0 0 8px rgba(255, 153, 0, 0.35);
        }
      }

      .process_box {
        width: 100%;
        height: vh(6);
        margin-top: vh(6);
        overflow: visible;
        background: rgba(0, 171, 250, 0.18);

        .process {
          height: 100%;
          position: relative;
          background: linear-gradient(270deg, #00abfa 0%, #90e3ff 100%);

          &.active {
            background: linear-gradient(270deg, #ff9900 0%, #fad789 100%);
          }

          .process_line {
            position: absolute;
            right: 0;
            top: 50%;
            width: vw(2);
            height: vh(8);
            border-radius: 1px;
            background: #fff;
            transform: translateY(-50%);
          }
        }
      }
    }
  }
  .side_list {
    width: vw(455);
    flex: 0 0 vw(455);
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .charts_bottom_box {
    width: 100%;
    .charts_container {
      height: vh(180);
      margin-top: vh(6);
      position: relative;
    }
  }
  .item_box {
    display: flex;
    flex-direction: column;
    width: 100%;
    .item_title_box {
      width: calc(100% - vw(40));
      height: vh(36);
      background: url("@/assets/image/box_title_bg.png") no-repeat center;
      background-size: 100% 100%;
      margin-bottom: vh(6);
      font-family: YouSheBiaoTiHei;
      font-weight: 400;
      font-size: vw(24);
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding-left: vw(40);
    }
  }
}
.data_loading_skeleton {
  position: absolute;
  z-index: 30;
  inset: 0;
  display: flex;
  min-width: 0;
  background: rgba(2, 15, 28, 0.96);
  backdrop-filter: blur(1px);
  .skeleton_columns {
    display: grid;
    grid-template-columns: vw(455) minmax(0, 1fr) vw(455);
    gap: vw(12);
    width: 100%;
    height: 100%;
    min-width: 0;
    min-height: 0;
  }
  .skeleton_column {
    display: flex;
    flex-direction: column;
    gap: vh(7);
    min-width: 0;
    min-height: 0;
  }
  .skeleton_section {
    display: flex;
    flex: 1 1 0;
    flex-direction: column;
    min-width: 0;
    min-height: 0;
  }
  .skeleton_overview {
    flex: 0 0 vh(282);
  }
  .skeleton_alert {
    flex: 0 0 vh(322);
  }
  .skeleton_title {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 0 0 vh(36);
    width: calc(100% - vw(40));
    margin-bottom: vh(6);
    padding: 0 vw(14) 0 vw(40);
    box-sizing: border-box;
    background: linear-gradient(90deg, rgba(0, 173, 221, 0.38), rgba(3, 38, 62, 0.2) 78%, transparent);
    &::before {
      position: absolute;
      top: 50%;
      left: vw(6);
      width: vw(23);
      height: vh(23);
      border: 1px solid rgba(115, 245, 255, 0.9);
      background: linear-gradient(135deg, rgba(0, 230, 255, 0.8), rgba(0, 94, 156, 0.58));
      box-shadow: 0 0 12px rgba(0, 212, 255, 0.36);
      content: "";
      transform: translateY(-50%) rotate(45deg);
    }
    i:first-child {
      width: 48%;
      height: vh(12);
    }
    i:last-child {
      width: vw(52);
      height: vh(5);
      background: repeating-linear-gradient(110deg, #ff9d19 0 vw(8), transparent vw(8) vw(13));
    }
  }
  .skeleton_panel {
    position: relative;
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
    box-sizing: border-box;
    border: 1px solid rgba(0, 198, 235, 0.38);
    background: linear-gradient(145deg, rgba(4, 32, 52, 0.76), rgba(4, 42, 67, 0.52));
    box-shadow: inset 0 0 20px rgba(0, 120, 200, 0.1);
    &::before,
    &::after {
      position: absolute;
      z-index: 2;
      width: vw(13);
      height: vh(13);
      border-color: #00d4ff;
      border-style: solid;
      content: "";
    }
    &::before {
      top: -1px;
      left: -1px;
      border-width: 2px 0 0 2px;
    }
    &::after {
      right: -1px;
      bottom: -1px;
      border-width: 0 2px 2px 0;
    }
  }
  .skeleton_overview_panel {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    padding: vh(14) vw(14);
  }
  .skeleton_metric_group {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 0;
    padding: 0 vw(10);
    &:first-child {
      border-right: 1px solid rgba(0, 212, 255, 0.25);
    }
  }
  .skeleton_metric {
    display: flex;
    align-items: center;
    gap: vw(9);
    min-height: 0;
    .skeleton_metric_icon {
      flex: 0 0 vw(42);
      width: vw(42);
      height: vh(38);
      border-radius: 50%;
      opacity: 0.72;
    }
    .skeleton_metric_copy {
      display: flex;
      flex: 1;
      flex-direction: column;
      gap: vh(6);
      min-width: 0;
      i:first-child {
        width: 74%;
        height: vh(8);
      }
      i:last-child {
        width: 58%;
        height: vh(13);
      }
    }
  }
  .skeleton_age_panel,
  .skeleton_alert_panel {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    padding: vh(12) vw(14);
  }
  .skeleton_ring {
    display: block;
    flex: 0 0 auto;
    width: min(34%, vw(150));
    aspect-ratio: 1;
    box-sizing: border-box;
    border: vw(14) solid rgba(0, 157, 223, 0.34);
    border-top-color: rgba(0, 226, 245, 0.7);
    border-right-color: rgba(0, 226, 245, 0.5);
    border-radius: 50%;
    background: transparent !important;
    animation: none !important;
  }
  .skeleton_age_legend,
  .skeleton_status_lines {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    gap: vh(10);
    width: 40%;
    height: 72%;
    i {
      display: block;
      width: 92%;
      height: vh(9);
    }
    i:nth-child(even) {
      width: 72%;
    }
  }
  .skeleton_chart_panel {
    display: flex;
    align-items: flex-end;
    justify-content: space-evenly;
    padding: 0 8% 12%;
  }
  .skeleton_chart_grid {
    position: absolute;
    inset: 14% 7% 18%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    i {
      border-top: 1px dashed rgba(103, 158, 186, 0.26);
    }
  }
  .skeleton_bars {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: flex-end;
    justify-content: space-around;
    width: 88%;
    height: 74%;
    i {
      width: 5%;
      height: 32%;
      min-height: vh(10);
      opacity: 0.76;
      &:nth-child(3n) { height: 68%; }
      &:nth-child(4n) { height: 45%; }
      &:nth-child(5n) { height: 82%; }
    }
  }
  .skeleton_map_panel {
    position: relative;
    flex: 1 1 auto;
    min-width: 0;
    min-height: 0;
    overflow: hidden;
  }
  .skeleton_breadcrumb {
    position: absolute;
    top: vh(112);
    left: vw(20);
    display: flex;
    align-items: center;
    gap: vw(9);
    i {
      width: vw(28);
      height: vh(9);
      border-radius: 2px;
      background: rgba(76, 164, 194, 0.42);
    }
    i:last-child { width: vw(42); }
  }
  .skeleton_map_board {
    position: absolute;
    z-index: 2;
    top: vh(4);
    left: 50%;
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: vw(12);
    width: 76%;
    padding: vh(15) vw(18);
    box-sizing: border-box;
    transform: translateX(-50%);
    background: rgba(4, 25, 44, 0.86);
    border: 1px solid rgba(0, 198, 235, 0.34);
    i {
      height: vh(64);
      border: 1px solid rgba(0, 212, 255, 0.55);
    }
  }
  .skeleton_map_shape {
    position: absolute;
    top: 56%;
    left: 50%;
    width: 74%;
    height: 58%;
    opacity: 0.62;
    clip-path: polygon(25% 6%, 40% 3%, 50% 12%, 66% 15%, 78% 12%, 87% 25%, 94% 38%, 85% 51%, 90% 66%, 80% 77%, 70% 77%, 66% 94%, 53% 91%, 47% 79%, 34% 82%, 28% 67%, 12% 67%, 8% 51%, 17% 39%, 12% 25%, 23% 20%);
    transform: translate(-50%, -50%);
  }
  .skeleton_map_legend {
    position: absolute;
    right: 6%;
    bottom: vh(8);
    left: 6%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: vw(24);
    height: vh(38);
    border: 1px solid rgba(0, 198, 235, 0.3);
    background: rgba(4, 25, 44, 0.48);
    i {
      display: flex;
      align-items: center;
      gap: vw(6);
      b:first-child { width: vw(26); height: vh(9); }
      b:last-child { width: vw(38); height: vh(7); background: rgba(92, 155, 185, 0.24); }
    }
  }
  .skeleton_center_bottom {
    display: flex;
    flex: 0 0 vh(222);
    gap: vw(8);
    .skeleton_section { width: calc(50% - vw(4)); }
    .skeleton_chart_panel { min-height: 0; }
  }
  .skeleton_alert_panel {
    justify-content: space-around;
    .skeleton_ring { width: min(31%, vw(132)); }
    .skeleton_status_lines { width: 42%; }
  }
  .skeleton_rank_panel {
    display: flex;
    flex-direction: column;
    gap: vh(9);
    padding: vh(12) vw(12);
  }
  .skeleton_rank_row {
    display: flex;
    flex: 1 1 0;
    flex-direction: column;
    justify-content: center;
    gap: vh(8);
    min-height: 0;
    padding: vh(6) vw(10);
    box-sizing: border-box;
    background: rgba(8, 85, 150, 0.2);
    span {
      display: flex;
      align-items: center;
      justify-content: space-between;
      i:first-child { width: 56%; height: vh(9); }
      i:last-child { width: 12%; height: vh(11); }
    }
    > i { width: 100%; height: vh(6); }
  }
  .skeleton_loading_label {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 4;
    display: flex;
    align-items: center;
    gap: vw(9);
    padding: vh(9) vw(14);
    border: 1px solid rgba(0, 212, 255, 0.48);
    color: #c8f5ff;
    background: rgba(3, 26, 45, 0.96);
    box-shadow: 0 0 vw(18) rgba(0, 195, 245, 0.14);
    font-size: vw(13);
    white-space: nowrap;
    transform: translate(-50%, -50%);
  }
  .skeleton_spinner {
    width: vw(14);
    height: vw(14);
    border: 2px solid rgba(0, 226, 245, 0.26);
    border-top-color: #00d4ff;
    border-radius: 50%;
    animation: data-loading-spin 0.8s linear infinite;
  }
  .skeleton_shimmer {
    display: block;
    background: linear-gradient(100deg, rgba(13, 64, 94, 0.62) 25%, rgba(35, 122, 161, 0.56) 45%, rgba(13, 64, 94, 0.62) 65%);
    background-size: 220% 100%;
    border-radius: 2px;
    animation: data-loading-shimmer 1.6s ease-in-out infinite;
  }
}
@keyframes data-loading-shimmer {
  0% { background-position: 100% 0; }
  100% { background-position: -120% 0; }
}
@keyframes data-loading-spin {
  to { transform: rotate(360deg); }
}
@media (prefers-reduced-motion: reduce) {
  .data_loading_skeleton .skeleton_shimmer,
  .data_loading_skeleton .skeleton_spinner,
  .map_loading_overlay .map_loading_shape {
    animation: none;
  }
}
.empty_image {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 2;
  display: block;
  width: 45%;
  max-width: 320px;
  max-height: 65%;
  height: auto;
  object-fit: contain;
  margin: 0;
  transform: translate(-50%, -50%);
}
.nothing {
  display: block;
  width: 45%;
  max-width: 320px;
  max-height: 65%;
  height: auto;
  object-fit: contain;
  margin: 0 auto;
}
.center_num {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  pointer-events: none;
  z-index: 3;
  &.center_num--left {
    left: 30%;
  }
  .num {
    font-family: $font-number;
    font-weight: 700;
    font-size: vw(30);
    color: #7ff3ff;
    text-shadow: 0 0 14px rgba(0, 212, 255, 0.6);
    line-height: 1.1;
  }
  .label {
    font-size: vw(12);
    color: #9fd8e8;
    margin-top: vh(4);
  }
}
.map_board {
  position: absolute;
  top: vh(4);
  left: 50%;
  transform: translateX(-50%);
  width: 76%;
  box-sizing: border-box;
  padding: vh(15) vw(18) vh(15);
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: vw(12);
  background-color: rgba(4, 25, 44, 0.72);
  box-shadow:
    inset 0 0 28px rgba(0, 120, 200, 0.18),
    0 0 22px rgba(0, 30, 60, 0.22);
  z-index: 5;
  pointer-events: none;
  .board_item {
    position: relative;
    min-width: 0;
    height: vh(64);
    box-sizing: border-box;
    padding: vh(8) vw(10);
    border: 1px solid rgba(0, 212, 255, 0.72);
    border-radius: 0;
    background-color: rgba(5, 35, 58, 0.58);
    box-shadow: inset 0 0 18px rgba(0, 169, 255, 0.14);
    display: grid;
    grid-template-rows: 1fr 1fr;
    align-items: center;
    justify-items: center;
    overflow: visible;
    .board_label {
      max-width: 100%;
      white-space: nowrap;
      font-size: vw(13);
      line-height: 1.2;
      letter-spacing: vw(0.3);
      color: #d9f0f1;
      text-shadow: 0 0 8px rgba(0, 212, 255, 0.32);
    }
    .board_num {
      font-family: $font-number;
      font-weight: 700;
      font-size: vw(28);
      color: #f2fbff;
      line-height: 1.1;
      text-shadow:
        0 0 8px rgba(0, 212, 255, 0.65),
        0 0 18px rgba(0, 119, 200, 0.35);
    }
    &--online {
      .board_label {
        color: #a6f5ce;
      }
      .board_num {
        color: #00e68a;
        text-shadow:
          0 0 8px rgba(0, 230, 138, 0.65),
          0 0 18px rgba(0, 171, 102, 0.35);
      }
    }
    &--offline {
      .board_label {
        color: #ffd0a8;
      }
      .board_num {
        color: #ff906e;
        text-shadow:
          0 0 8px rgba(255, 144, 110, 0.65),
          0 0 18px rgba(205, 68, 42, 0.35);
      }
    }
  }
}
.elevator_list_overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 30;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: vh(24) vw(24);
  box-sizing: border-box;
  background: rgba(1, 12, 24, 0.68);
  color: #d9f0f1;
}
.elevator_list_modal {
  width: 58vw;
  min-width: 720px;
  max-width: calc(100vw - vw(48));
  max-height: calc(100vh - vh(56));
  overflow: hidden;
  border: 1px solid rgba(0, 180, 255, 0.78);
  border-radius: 10px;
  background:
    linear-gradient(135deg, rgba(7, 34, 57, 0.98), rgba(3, 22, 40, 0.98)),
    #061c31;
  box-shadow:
    0 0 0 1px rgba(0, 212, 255, 0.12),
    0 0 28px rgba(0, 153, 255, 0.2),
    inset 0 0 28px rgba(0, 118, 190, 0.1);
  outline: none;
}
.elevator_list_header {
  min-height: vh(60);
  box-sizing: border-box;
  padding: vh(12) vw(24) vh(10) vw(26);
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(0, 180, 255, 0.32);
  background: rgba(4, 35, 61, 0.56);
  h2 {
    margin: 0;
    color: #00e5ff;
    font-size: vw(22);
    font-weight: 400;
    line-height: 1.2;
    text-shadow: 0 0 10px rgba(0, 212, 255, 0.48);
  }
  .elevator_list_scope {
    display: block;
    margin-top: vh(4);
    color: #8bb9c9;
    font-size: vw(12);
    line-height: 1.2;
  }
}
.elevator_list_close {
  width: vh(28);
  height: vh(28);
  padding: 0;
  border: 0;
  color: #00e5ff;
  background: transparent;
  cursor: pointer;
  font-size: vh(30);
  font-weight: 300;
  line-height: vh(24);
  transition: color 160ms ease, text-shadow 160ms ease;
  &:hover,
  &:focus-visible {
    color: #ffffff;
    outline: none;
    text-shadow: 0 0 12px rgba(0, 229, 255, 0.85);
  }
}
.elevator_list_body {
  padding: vh(18) vw(20) vh(20);
}
.elevator_list_filters {
  display: flex;
  align-items: center;
  gap: vw(10);
  margin-bottom: vh(14);
}
.elevator_list_filter {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  min-width: 0;
  gap: vw(6);
  color: #9fd8e8;
  font-size: vw(13);
  white-space: nowrap;
  input {
    width: vw(180);
    height: vh(30);
    box-sizing: border-box;
    padding: 0 vw(10);
    border: 1px solid rgba(34, 117, 165, 0.42);
    border-radius: 4px;
    color: #f2fbff;
    background: rgba(5, 35, 58, 0.7);
    font: inherit;
    outline: none;
    &::placeholder {
      color: #6f9aad;
    }
    &:focus {
      border-color: #00d4ff;
      box-shadow: 0 0 10px rgba(0, 212, 255, 0.2);
    }
  }
}
.elevator_list_action {
  height: vh(30);
  padding: 0 vw(20);
  border: 1px solid rgba(34, 117, 165, 0.42);
  border-radius: 4px;
  color: #c9e6f0;
  background: rgba(5, 35, 58, 0.74);
  cursor: pointer;
  font: inherit;
  font-size: vw(13);
  white-space: nowrap;
  transition: border-color 160ms ease, color 160ms ease, background 160ms ease;
  &:hover,
  &:focus-visible {
    border-color: #00d4ff;
    color: #ffffff;
    outline: none;
  }
  &--primary {
    border-color: transparent;
    color: #03263b;
    background: #00c9e6;
    &:hover,
    &:focus-visible {
      border-color: #6cf2ff;
      color: #021b2c;
      background: #43e6f5;
    }
  }
}
.elevator_list_table_wrap {
  max-height: vh(440);
  overflow: auto;
  scrollbar-color: rgba(0, 212, 255, 0.42) rgba(4, 31, 52, 0.65);
  scrollbar-width: thin;
}
.elevator_list_table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 vh(6);
  table-layout: fixed;
  color: #eaf8fb;
  font-size: vw(14);
  th,
  td {
    height: vh(44);
    padding: 0 vw(10);
    text-align: center;
    vertical-align: middle;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  th {
    height: vh(48);
    color: #eefaff;
    background: rgba(10, 65, 105, 0.84);
    font-weight: 400;
  }
  th:nth-child(1),
  td:nth-child(1) {
    width: 9%;
  }
  th:nth-child(2),
  td:nth-child(2) {
    width: 25%;
  }
  th:nth-child(3),
  td:nth-child(3),
  th:nth-child(4),
  td:nth-child(4) {
    width: 17%;
  }
  th:nth-child(5),
  td:nth-child(5) {
    width: 15%;
  }
  th:nth-child(6),
  td:nth-child(6) {
    width: 17%;
  }
  tbody tr {
    background: rgba(3, 30, 51, 0.82);
    transition: background 160ms ease, box-shadow 160ms ease;
    &:nth-child(even) {
      background: rgba(6, 43, 70, 0.74);
    }
    &:hover {
      background: rgba(0, 118, 171, 0.48);
      box-shadow: inset 0 0 0 1px rgba(0, 212, 255, 0.34);
    }
  }
  .elevator_list_status {
    &.is-online {
      color: #00e68a;
      text-shadow: 0 0 8px rgba(0, 230, 138, 0.45);
    }
    &.is-offline {
      color: #ff4b59;
      text-shadow: 0 0 8px rgba(255, 75, 89, 0.4);
    }
  }
  .elevator_list_view {
    min-width: vw(54);
    height: vh(28);
    padding: 0 vw(10);
    border: 0;
    border-radius: 4px;
    color: #effcff;
    background: #00c9d8;
    cursor: pointer;
    font: inherit;
    font-size: vw(13);
    line-height: vh(28);
    transition: background 160ms ease, box-shadow 160ms ease;
    &:hover,
    &:focus-visible {
      background: #29e3ef;
      box-shadow: 0 0 10px rgba(0, 212, 255, 0.38);
      outline: none;
    }
  }
  .elevator_list_empty td {
    height: vh(100);
    color: #7fa1b3;
  }
}
.elevator_monitor_overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 40;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: vh(24) vw(24);
  box-sizing: border-box;
  background: rgba(1, 10, 20, 0.46);
}
.elevator_monitor_modal {
  width: 52vw;
  min-width: 800px;
  max-width: calc(100vw - vw(48));
  max-height: calc(100vh - vh(56));
  overflow: hidden;
  border: 1px solid rgba(0, 180, 255, 0.78);
  border-radius: 8px;
  color: #d9f0f1;
  background:
    linear-gradient(135deg, rgba(7, 34, 57, 0.99), rgba(3, 22, 40, 0.99)),
    #061c31;
  box-shadow:
    0 0 0 1px rgba(0, 212, 255, 0.12),
    0 0 30px rgba(0, 153, 255, 0.24),
    inset 0 0 28px rgba(0, 118, 190, 0.1);
  outline: none;
}
.elevator_monitor_header {
  min-height: vh(54);
  box-sizing: border-box;
  padding: vh(10) vw(20) vh(8) vw(22);
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(0, 180, 255, 0.32);
  background: rgba(4, 35, 61, 0.56);
  h2 {
    margin: 0;
    color: #00e5ff;
    font-size: vw(20);
    font-weight: 400;
    line-height: 1.2;
    text-shadow: 0 0 10px rgba(0, 212, 255, 0.48);
  }
}
.elevator_monitor_close {
  width: vh(28);
  height: vh(28);
  padding: 0;
  border: 0;
  color: #00e5ff;
  background: transparent;
  cursor: pointer;
  font-size: vh(30);
  font-weight: 300;
  line-height: vh(24);
  transition: color 160ms ease, text-shadow 160ms ease;
  &:hover,
  &:focus-visible {
    color: #ffffff;
    outline: none;
    text-shadow: 0 0 12px rgba(0, 229, 255, 0.85);
  }
}
.elevator_monitor_info {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: vw(18);
  padding: vh(16) vw(22) vh(12);
  color: #b5dce7;
  font-size: vw(12);
  line-height: 1.4;
  white-space: nowrap;
  .elevator_monitor_info_item {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  span {
    color: #73b4ca;
  }
}
.elevator_monitor_body {
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(vw(280), 0.86fr);
  gap: vw(16);
  padding: 0 vw(22) vh(22);
}
.elevator_monitor_video {
  min-height: vh(330);
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000000;
  box-shadow: inset 0 0 0 1px rgba(93, 147, 166, 0.14);
}
.elevator_monitor_play {
  width: 0;
  height: 0;
  margin-left: vw(8);
  border-top: vh(22) solid transparent;
  border-bottom: vh(22) solid transparent;
  border-left: vw(34) solid rgba(242, 251, 255, 0.84);
  filter: drop-shadow(0 0 8px rgba(255, 255, 255, 0.2));
}
.elevator_monitor_side {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: vh(16);
}
.elevator_monitor_status_grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: vh(10) vw(8);
}
.elevator_monitor_status_card {
  min-height: vh(66);
  box-sizing: border-box;
  padding: vh(8) vw(12);
  display: flex;
  flex-direction: column;
  justify-content: center;
  border: 1px solid rgba(0, 174, 255, 0.76);
  background: rgba(5, 35, 58, 0.72);
  strong {
    color: #f2fbff;
    font-family: $font-number;
    font-size: vw(20);
    font-weight: 700;
    line-height: 1.1;
    white-space: nowrap;
  }
  span {
    margin-top: vh(6);
    color: #9cc7d3;
    font-size: vw(11);
    line-height: 1.2;
    white-space: nowrap;
  }
}
.elevator_monitor_statistics {
  padding-top: vh(2);
  h3 {
    margin: 0 0 vh(8);
    display: flex;
    align-items: center;
    color: #00e5ff;
    font-size: vw(17);
    font-weight: 400;
    line-height: 1.2;
    text-shadow: 0 0 8px rgba(0, 212, 255, 0.42);
    &::before {
      width: vw(4);
      height: vh(18);
      margin-right: vw(8);
      background: #00e5ff;
      box-shadow: 0 0 8px rgba(0, 229, 255, 0.72);
      content: "";
    }
    &::after {
      flex: 1;
      height: 1px;
      margin-left: vw(12);
      background: linear-gradient(90deg, rgba(0, 212, 255, 0.5), transparent);
      content: "";
    }
  }
}
.elevator_monitor_statistics_grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0 vw(14);
  div {
    display: flex;
    flex-direction: row;
    align-items: baseline;
    justify-content: space-between;
    gap: vw(8);
    min-width: 0;
    padding: vh(8) 0;
    border-bottom: 1px solid rgba(65, 135, 165, 0.26);
    &:last-child {
      grid-column: 1 / -1;
    }
  }
  span {
    min-width: 0;
    overflow: hidden;
    color: #79aebe;
    font-size: vw(11);
    line-height: 1.2;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  strong {
    color: #effcff;
    font-family: $font-number;
    font-size: vw(15);
    font-weight: 700;
    line-height: 1.2;
    white-space: nowrap;
    text-shadow: 0 0 8px rgba(0, 212, 255, 0.32);
  }
}
.module_loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 2;
  .loading_spinner {
    width: vw(28);
    height: vw(28);
    border: 3px solid rgba(0, 212, 255, 0.2);
    border-top-color: #00d4ff;
    border-radius: 50%;
    animation: loading-spin 0.8s linear infinite;
  }
}
@keyframes loading-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
